import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.content');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-content',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.content/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #172033;
}

.content-notebook-scale {
  width: 100%;
  min-width: 0;
}

.content-workbench-header {
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
}

.content-workbench-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(290px, 320px);
  align-items: start;
  gap: 18px;
}

.content-panel {
  min-width: 0;
  border: 1px solid #dbe3ec;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.045);
}

.content-preview-panel {
  overflow: hidden;
  min-height: 700px;
}

.content-settings-panel {
  position: sticky;
  top: 72px;
  overflow: visible;
}

.content-media-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-bottom: 1px solid #e5eaf0;
  padding: 0 18px;
}

.content-media-tabs button {
  position: relative;
  display: inline-flex;
  min-height: 52px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
  transition: color 160ms ease;
}

.content-media-tabs button::after {
  position: absolute;
  right: 12px;
  bottom: -1px;
  left: 12px;
  height: 2px;
  border-radius: 999px 999px 0 0;
  background: transparent;
  content: "";
}

.content-media-tabs button:hover,
.content-media-tabs button.is-active {
  color: #1d4ed8;
}

.content-media-tabs button.is-active::after {
  background: #2563eb;
}

.content-review-empty {
  display: flex;
  min-height: 520px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px;
  text-align: center;
}

.content-preview-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 20px 16px;
}

.content-preview-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

.content-secondary-button,
.content-primary-button {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 9px;
  padding: 0 15px;
  font-size: 12px;
  font-weight: 700;
  transition: 150ms ease;
}

.content-secondary-button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}

.content-secondary-button:hover {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.content-secondary-button.is-confirmed {
  border-color: #86efac;
  background: #f0fdf4;
  color: #047857;
}

.content-primary-button {
  border: 1px solid #1d4ed8;
  background: #1d4ed8;
  color: #fff;
  box-shadow: 0 5px 12px rgba(29, 78, 216, 0.16);
}

.content-primary-button:hover {
  background: #1e40af;
}

.content-primary-button.is-confirmed {
  border-color: #059669;
  background: #059669;
}

.content-secondary-button:disabled,
.content-primary-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.content-model-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 0 20px 14px;
  border: 1px solid #ede9fe;
  border-radius: 10px;
  background: #faf9ff;
  padding: 10px 12px;
}

.content-filter-button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 7px;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  background: #fff;
  padding: 0 10px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.content-filter-button small {
  border-radius: 999px;
  background: #f1f5f9;
  padding: 1px 6px;
  font-size: 9px;
}

.content-filter-button.is-active {
  border-color: #6d28d9;
  background: #6d28d9;
  color: #fff;
}

.content-filter-button.is-active small {
  background: rgba(255, 255, 255, 0.2);
}

.content-master-media {
  position: relative;
  display: flex;
  aspect-ratio: 16/9;
  max-height: 570px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0 20px;
  border: 1px solid #d6dee8;
  border-radius: 12px;
  background: #0f172a;
}

.content-master-media > img,
.content-master-media > video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-master-audio {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 36px;
  background: #0f2435;
}

.content-master-audio img {
  width: min(100%, 720px);
  max-height: 58%;
  border-radius: 10px;
  object-fit: contain;
}

.content-master-audio audio {
  width: min(100%, 720px);
}

.content-audio-placeholder,
.content-master-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #cbd5e1;
  font-size: 12px;
}

.content-audio-placeholder i,
.content-master-placeholder i {
  font-size: 32px;
}

.content-master-placeholder {
  position: absolute;
  inset: 0;
  background: #0f172a;
}

.content-thumbnail-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin: 14px 20px 0;
}

.content-thumbnail {
  position: relative;
  aspect-ratio: 16/9;
  min-width: 0;
  overflow: hidden;
  border: 2px solid transparent;
  border-radius: 10px;
  background: #eef2f7;
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.content-thumbnail:hover {
  transform: translateY(-1px);
  border-color: #bfdbfe;
}

.content-thumbnail.is-selected {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.13);
}

.content-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-thumbnail-index {
  position: absolute;
  z-index: 2;
  top: 7px;
  left: 7px;
  display: flex;
  width: 23px;
  height: 23px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.72);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  backdrop-filter: blur(4px);
}

.content-thumbnail.is-selected .content-thumbnail-index {
  background: #2563eb;
}

.content-thumbnail-meta {
  position: absolute;
  right: 7px;
  bottom: 7px;
  left: 7px;
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border-radius: 6px;
  background: rgba(15, 23, 42, 0.78);
  padding: 4px 7px;
  color: #fff;
  backdrop-filter: blur(4px);
}

.content-thumbnail-meta strong,
.content-thumbnail-meta small {
  overflow: hidden;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-thumbnail-meta strong {
  font-weight: 800;
}

.content-thumbnail-meta small {
  color: #cbd5e1;
}

.content-thumbnail-check {
  position: absolute;
  right: 8px;
  bottom: 8px;
  color: #10b981;
  font-size: 20px;
  filter: drop-shadow(0 1px 3px rgba(255, 255, 255, 0.8));
}

.content-thumbnail-batch-check {
  position: absolute;
  right: 8px;
  top: 8px;
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #1d4ed8;
  color: #fff;
  font-size: 10px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.24);
}

.content-thumbnail-placeholder {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 24px;
}

.content-selected-asset {
  margin: 16px 20px 20px;
  border: 1px solid #e1e7ee;
  border-radius: 11px;
  background: #fff;
}

.content-selected-asset-heading {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf1f5;
  padding: 12px 15px;
}

.content-selected-asset-heading h3 {
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.content-selected-asset-heading p {
  margin-top: 3px;
  color: #7c8a9c;
  font-size: 10px;
}

.content-asset-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}

.content-asset-actions button {
  min-height: 31px;
  border: 1px solid #d6dee8;
  border-radius: 7px;
  padding: 0 10px;
  background: #fff;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.content-asset-actions button:hover {
  border-color: #93c5fd;
  color: #1d4ed8;
}

.content-asset-actions button.is-danger {
  border-color: #fecaca;
  color: #dc2626;
}

.content-asset-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.content-asset-detail-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 15px;
}

.content-asset-detail-grid > div {
  min-width: 0;
  border-right: 1px solid #edf1f5;
  padding: 0 15px;
}

.content-asset-detail-grid > div:first-child {
  padding-left: 0;
}

.content-asset-detail-grid > div:last-child {
  border-right: 0;
  padding-right: 0;
}

.content-asset-detail-grid dt {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.content-asset-detail-grid dd {
  overflow: hidden;
  margin-top: 5px;
  color: #334155;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-status-badge {
  display: inline-flex;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 9px;
}

.content-status-badge.is-success {
  background: #ecfdf5;
  color: #047857;
}

.content-status-badge.is-danger {
  background: #fef2f2;
  color: #b91c1c;
}

.content-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #edf1f5;
  padding: 14px 20px;
  color: #64748b;
  font-size: 11px;
}

.content-pagination > div {
  display: flex;
  gap: 8px;
}

.content-overview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-top: 1px solid #edf1f5;
  padding: 15px 20px;
  color: #64748b;
}

.content-overview h3,
.content-overview strong {
  color: #334155;
  font-size: 10px;
  font-weight: 800;
}

.content-overview p {
  margin-top: 3px;
  font-size: 9px;
  line-height: 1.5;
}

.content-overview > p {
  max-width: 420px;
  margin-top: 0;
  text-align: right;
}

.content-overview > p strong,
.content-overview > p span {
  display: block;
}

.content-pagination button {
  min-height: 34px;
  border: 1px solid #d6dee8;
  border-radius: 7px;
  padding: 0 12px;
  background: #fff;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.content-pagination button:disabled {
  opacity: 0.4;
}

.content-settings-form {
  display: flex;
  flex-direction: column;
}

.content-settings-header {
  display: flex;
  min-height: 68px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 17px 18px 14px;
}

.content-settings-eyebrow {
  margin-bottom: 2px;
  color: #2563eb;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.content-settings-header h2 {
  color: #111827;
  font-size: 15px;
  font-weight: 800;
}

.content-settings-header p {
  margin-top: 4px;
  color: #7c8a9c;
  font-size: 10px;
  line-height: 1.5;
}

.content-running-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #eff6ff;
  padding: 4px 8px;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 800;
}

.content-settings-section {
  position: relative;
  border-top: 1px solid #e8edf3;
  padding: 16px 18px;
}

.content-settings-section > h3 {
  margin-bottom: 14px;
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.content-settings-accordion-row {
  border-top: 1px solid #e8edf3;
  background: #fff;
}

.content-settings-accordion-trigger {
  display: grid;
  width: 100%;
  min-height: 64px;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 11px;
  border: 0;
  padding: 11px 18px;
  background: transparent;
  text-align: left;
  transition: background-color 160ms ease;
}

.content-settings-accordion-trigger:not(:disabled):hover {
  background: #f8fafc;
}

.content-settings-accordion-trigger:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: -2px;
}

.content-settings-accordion-icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 13px;
}

.content-settings-accordion-icon.is-reference {
  background: #f5f3ff;
  color: #7c3aed;
}

.content-settings-accordion-icon.is-intensity {
  background: #ecfdf5;
  color: #059669;
}

.content-settings-accordion-icon.is-generation {
  background: #fff7ed;
  color: #ea580c;
}

.content-settings-accordion-copy {
  min-width: 0;
}

.content-settings-accordion-copy strong,
.content-settings-accordion-copy small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-settings-accordion-copy strong {
  color: #172033;
  font-size: 11px;
  font-weight: 800;
}

.content-settings-accordion-copy small {
  margin-top: 3px;
  color: #7c8a9c;
  font-size: 9px;
  line-height: 1.4;
}

.content-settings-accordion-state {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #94a3b8;
  font-size: 10px;
}

.content-settings-accordion-row.is-open .content-settings-accordion-trigger {
  background: #f8fbff;
}

.content-settings-accordion-row.is-open .content-settings-accordion-copy strong,
.content-settings-accordion-row.is-open .content-settings-accordion-state {
  color: #1d4ed8;
}

.content-settings-accordion-row.is-locked .content-settings-accordion-trigger {
  cursor: not-allowed;
}

.content-settings-accordion-row.is-locked .content-settings-accordion-icon {
  background: #f1f5f9;
  color: #94a3b8;
}

.content-settings-accordion-row.is-locked .content-settings-accordion-copy strong {
  color: #475569;
}

.content-settings-section > .content-settings-accordion-row.is-prompt-row {
  margin: 16px -18px -16px;
}

.content-settings-section > .content-settings-accordion-row.is-prompt-row.is-open {
  margin-bottom: 0;
}

.content-settings-section > .content-prompt-selector.content-settings-accordion-body {
  margin-top: 0;
  border-top: 0;
  padding-top: 16px;
}

.content-settings-accordion-body {
  animation: content-settings-accordion-in 160ms ease-out;
}

.content-settings-locked-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  border-top: 1px solid #e8edf3;
  background: rgba(255, 255, 255, 0.98);
  padding: 13px 18px 16px;
  backdrop-filter: blur(8px);
}

.content-settings-locked-footer p {
  margin-bottom: 8px;
  color: #7c8a9c;
  font-size: 9px;
  text-align: center;
}

.content-settings-locked-footer button {
  display: inline-flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 9px;
  background: #dbe5f5;
  color: #70829d;
  font-size: 11px;
  font-weight: 800;
  cursor: not-allowed;
}

@keyframes content-settings-accordion-in {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.content-reference-condition-section h3 {
  color: #172033;
  font-size: 12px;
  font-weight: 800;
}

.content-reference-condition-badge {
  display: inline-flex;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #ede9fe;
  padding: 4px 8px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-condition-card,
.content-reference-condition-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 11px;
  border: 1px solid #ddd6fe;
  border-radius: 10px;
  background: #faf9ff;
  padding: 10px;
}

.content-reference-condition-copy {
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.content-reference-condition-copy strong {
  color: #172033;
  font-size: 11px;
}

.content-reference-condition-copy p {
  margin-top: 3px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.35;
}

.content-reference-condition-copy p:last-child {
  color: #94a3b8;
}

.content-reference-condition-thumbnail {
  position: relative;
  width: 56px;
  height: 44px;
  flex: 0 0 auto;
  overflow: hidden;
  border: 1px solid #ddd6fe;
  border-radius: 8px;
  background: #ede9fe;
}

.content-reference-condition-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-reference-condition-thumbnail span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0);
  color: transparent;
  transition: 150ms ease;
}

.content-reference-condition-thumbnail:hover span,
.content-reference-condition-thumbnail:focus-visible span {
  background: rgba(15, 23, 42, 0.48);
  color: #fff;
}

.content-reference-condition-icon {
  display: flex;
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #ede9fe;
  color: #6d28d9;
}

.content-reference-condition-remove,
.content-reference-condition-empty > a {
  flex: 0 0 auto;
  border: 1px solid #c4b5fd;
  border-radius: 8px;
  background: #fff;
  padding: 6px 8px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-condition-empty > i {
  color: #8b5cf6;
  font-size: 18px;
}

.content-reference-condition-empty > div {
  min-width: 0;
  flex: 1;
}

.content-reference-condition-empty strong {
  color: #334155;
  font-size: 10px;
}

.content-reference-condition-empty p {
  margin-top: 2px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.45;
}

.content-reference-condition-guardrail {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 9px;
  border-radius: 8px;
  background: #ecfdf5;
  padding: 8px 9px;
  color: #047857;
  font-size: 9px;
  line-height: 1.5;
}

.content-reference-recommendations {
  margin-top: 12px;
  border-top: 1px solid #ede9fe;
  padding-top: 12px;
}

.content-reference-recommendation-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.content-reference-recommendation-heading strong {
  color: #4c1d95;
  font-size: 10px;
}

.content-reference-recommendation-heading p {
  margin-top: 3px;
  color: #64748b;
  font-size: 9px;
  line-height: 1.45;
}

.content-reference-recommendation-heading > span {
  flex: 0 0 auto;
  border-radius: 999px;
  background: #ede9fe;
  padding: 3px 7px;
  color: #6d28d9;
  font-size: 9px;
  font-weight: 800;
}

.content-reference-recommendation-list {
  display: grid;
  gap: 7px;
  margin-top: 9px;
}

.content-reference-recommendation-card {
  display: grid;
  min-width: 0;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #e9d5ff;
  border-radius: 9px;
  background: #fff;
  padding: 7px;
}

.content-reference-recommendation-card > img,
.content-reference-recommendation-placeholder {
  width: 48px;
  height: 38px;
  border-radius: 7px;
  background: #f3e8ff;
  object-fit: cover;
}

.content-reference-recommendation-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b5cf6;
}

.content-reference-recommendation-card > div:not(.content-reference-recommendation-placeholder) {
  min-width: 0;
}

.content-reference-recommendation-card strong {
  display: block;
  color: #334155;
  font-size: 9px;
}

.content-reference-recommendation-card p {
  margin-top: 3px;
  color: #64748b;
  font-size: 8px;
}

.content-reference-recommendation-card button,
.content-reference-recommendation-empty a,
.content-reference-recommendation-empty button {
  flex: 0 0 auto;
  border: 1px solid #c4b5fd;
  border-radius: 7px;
  background: #fff;
  padding: 5px 7px;
  color: #6d28d9;
  font-size: 8px;
  font-weight: 800;
}

.content-reference-recommendation-status,
.content-reference-recommendation-empty {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 9px;
  border-radius: 9px;
  background: #f5f3ff;
  padding: 9px;
  color: #6d28d9;
  font-size: 9px;
}

.content-reference-recommendation-empty {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
}

.content-reference-recommendation-empty strong,
.content-reference-recommendation-empty p {
  grid-column: 1;
}

.content-reference-recommendation-empty p {
  margin-top: 2px;
  color: #64748b;
  line-height: 1.45;
}

.content-reference-recommendation-empty a,
.content-reference-recommendation-empty button {
  grid-column: 2;
  grid-row: 1/span 2;
  align-self: center;
}

.content-reference-recommendation-empty.is-error {
  background: #fff1f2;
  color: #be123c;
}

.content-field {
  margin-top: 14px;
}

.content-field:first-of-type {
  margin-top: 0;
}

.content-field-label,
.content-field-row label,
.content-field-row span:first-child {
  display: block;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
}

.content-field-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.content-model-status,
.content-auto-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 999px;
  background: #ecfdf5;
  padding: 3px 7px;
  color: #047857;
  font-size: 9px;
  font-weight: 800;
}

.content-auto-badge.is-manual {
  background: #eff6ff;
  color: #1d4ed8;
}

.content-auto-badge.is-warning {
  background: #fff7ed;
  color: #c2410c;
}

.content-select-wrap {
  position: relative;
  margin-top: 8px;
}

.content-select-wrap select {
  width: 100%;
  min-height: 42px;
  appearance: none;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  padding: 8px 34px 8px 11px;
  color: #243244;
  font-size: 11px;
  font-weight: 700;
  outline: none;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.content-select-wrap select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.13);
}

.content-select-wrap > i {
  position: absolute;
  top: 50%;
  right: 12px;
  color: #94a3b8;
  font-size: 9px;
  pointer-events: none;
  transform: translateY(-50%);
}

.content-selected-patient-code {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 9px;
  color: #64748b;
  font-size: 9px;
}

.content-selected-patient-code > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-patient-setup-alert {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 9px;
  margin-top: 10px;
  border: 1px solid #fbbf24;
  border-radius: 9px;
  background: #fffbeb;
  padding: 10px;
  color: #92400e;
}

.content-patient-setup-alert > i {
  margin-top: 2px;
  color: #d97706;
  font-size: 12px;
}

.content-patient-setup-alert strong {
  display: block;
  font-size: 10px;
  font-weight: 800;
}

.content-patient-setup-alert p {
  margin-top: 3px;
  font-size: 9px;
  line-height: 1.5;
}

.content-patient-setup-alert a {
  display: inline-block;
  margin-top: 6px;
  border-radius: 6px;
  background: #fff;
  padding: 5px 7px;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 800;
}

.content-prompt-selector {
  margin-top: 14px;
  border-top: 1px solid #edf1f5;
  padding-top: 14px;
}

.content-prompt-selection-summary {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  border-left: 2px solid #2563eb;
  padding: 4px 0 4px 9px;
}

.content-prompt-selection-summary > div {
  min-width: 0;
}

.content-prompt-selection-summary span {
  display: block;
  color: #94a3b8;
  font-size: 8px;
  font-weight: 700;
}

.content-prompt-selection-summary > span {
  max-width: 45%;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-prompt-selection-summary strong {
  display: block;
  overflow: hidden;
  margin-top: 2px;
  color: #1e3a8a;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-prompt-warning {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 8px;
  margin-top: 10px;
  border: 1px solid #fed7aa;
  border-radius: 9px;
  background: #fff7ed;
  padding: 9px;
  color: #9a3412;
}

.content-prompt-warning > i {
  margin-top: 2px;
  font-size: 10px;
}

.content-prompt-warning strong {
  display: block;
  font-size: 10px;
}

.content-prompt-warning p {
  margin-top: 3px;
  font-size: 9px;
  line-height: 1.5;
}

.content-prompt-warning button {
  margin-top: 6px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #1d4ed8;
  cursor: pointer;
  font-size: 9px;
  font-weight: 800;
}

.content-prompt-preview {
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid #dbe4ee;
  border-radius: 9px;
  background: #fff;
}

.content-prompt-preview > summary {
  display: flex;
  min-height: 38px;
  cursor: pointer;
  list-style: none;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  color: #334155;
  font-size: 10px;
}

.content-prompt-preview > summary::-webkit-details-marker {
  display: none;
}

.content-prompt-preview > summary span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.content-prompt-preview > summary > i {
  color: #94a3b8;
  font-size: 8px;
  transition: transform 150ms ease;
}

.content-prompt-preview[open] > summary > i {
  transform: rotate(180deg);
}

.content-prompt-preview-body {
  display: grid;
  gap: 8px;
  border-top: 1px solid #edf1f5;
  background: #f8fafc;
  padding: 9px;
}

.content-prompt-layer {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
}

.content-prompt-layer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 7px;
  color: #475569;
}

.content-prompt-layer-header strong,
.content-prompt-layer-header span {
  display: block;
}

.content-prompt-layer-header strong {
  color: #1e293b;
  font-size: 9px;
}

.content-prompt-layer-header span {
  margin-top: 1px;
  color: #94a3b8;
  font-size: 8px;
}

.content-prompt-layer > label {
  display: block;
  margin-top: 7px;
  color: #64748b;
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
}

.content-prompt-readonly {
  max-height: 82px;
  overflow: auto;
  margin-top: 3px;
  border-radius: 6px;
  background: #f8fafc;
  padding: 7px;
  color: #475569;
  font-size: 9px;
  line-height: 1.5;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.content-prompt-language-note {
  border-radius: 6px;
  background: #eff6ff;
  padding: 7px 8px;
  color: #1e40af;
  font-size: 8px;
  line-height: 1.5;
}

.content-mapped-scenario {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  border-left: 2px solid #10b981;
  padding: 7px 0 7px 10px;
}

.content-mapped-scenario > div {
  min-width: 0;
}

.content-mapped-scenario > div span {
  display: block;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
}

.content-mapped-scenario strong {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #334155;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-mapped-scenario > p {
  grid-column: 1/-1;
  color: #64748b;
  font-size: 9px;
  line-height: 1.5;
}

.content-inline-warning {
  margin-top: 10px;
  border-radius: 8px;
  background: #fffbeb;
  padding: 9px 10px;
  color: #92400e;
  font-size: 10px;
  line-height: 1.5;
}

.content-inline-warning a {
  display: inline-block;
  margin-top: 4px;
  color: #1d4ed8;
  font-weight: 700;
}

.intensity-help > summary {
  display: inline-flex;
  cursor: pointer;
  list-style: none;
  align-items: center;
  gap: 7px;
  border-radius: 6px;
  color: #334155;
  font-size: 11px;
  font-weight: 800;
  outline: none;
}

.intensity-help > summary::-webkit-details-marker {
  display: none;
}

.intensity-help > summary i {
  color: #64748b;
  font-size: 12px;
}

.intensity-help > summary:focus-visible {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.16);
}

.content-intensity-popover {
  position: absolute;
  z-index: 10;
  top: 47px;
  right: 14px;
  width: min(245px, 100% - 28px);
  border: 1px solid #d7dee8;
  border-radius: 9px;
  background: #fff;
  padding: 12px 30px 12px 12px;
  color: #475569;
  font-size: 10px;
  line-height: 1.55;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.13);
}

.content-intensity-popover button {
  position: absolute;
  top: 7px;
  right: 7px;
  display: flex;
  width: 21px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: #94a3b8;
}

.content-intensity-steps {
  margin-top: 17px;
}

.content-intensity-steps input {
  width: 100%;
  height: 5px;
  border-radius: 999px;
  background: #dbe3ec;
  accent-color: #2563eb;
  cursor: pointer;
}

.content-intensity-steps input::-webkit-slider-thumb {
  width: 19px;
  height: 19px;
  appearance: none;
  border: 3px solid #fff;
  border-radius: 999px;
  background: #2563eb;
  box-shadow: 0 2px 7px rgba(37, 99, 235, 0.28);
}

.content-intensity-steps input::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border: 3px solid #fff;
  border-radius: 999px;
  background: #2563eb;
  box-shadow: 0 2px 7px rgba(37, 99, 235, 0.28);
}

.content-intensity-labels {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  color: #94a3b8;
  font-size: 9px;
}

.content-intensity-labels output {
  color: #2563eb;
  font-size: 10px;
  font-weight: 800;
}

.content-field-help {
  margin-top: 8px;
  color: #64748b;
  font-size: 9px;
}

.content-inline-info {
  margin-top: 8px;
  border-radius: 8px;
  background: #eff6ff;
  padding: 8px 9px;
  color: #1d4ed8;
  font-size: 9px;
  line-height: 1.5;
}

.content-scope-toggle {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  margin-top: 8px;
  border-radius: 9px;
  background: #f1f5f9;
  padding: 4px;
}

.content-scope-toggle button {
  min-height: 34px;
  border-radius: 7px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
}

.content-scope-toggle button.is-active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 5px rgba(15, 23, 42, 0.12);
}

.content-readonly-field {
  margin-top: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  background: #f8fafc;
  padding: 11px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.content-candidate-note {
  margin-top: 9px;
  border-radius: 8px;
  background: #eff6ff;
  padding: 9px 10px;
  color: #1e40af;
  font-size: 9px;
  line-height: 1.5;
}

.content-candidate-note strong {
  display: block;
  font-size: 10px;
}

.content-video-settings {
  display: grid;
  gap: 14px;
  margin-top: 14px;
}

.content-video-settings > .content-field {
  margin-top: 0;
}

.content-source-summary {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 8px;
  border: 1px solid #dbeafe;
  border-radius: 9px;
  background: #f7fbff;
  padding: 8px;
}

.content-source-summary img {
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  border-radius: 6px;
  object-fit: cover;
}

.content-source-summary div {
  min-width: 0;
}

.content-source-summary strong {
  display: block;
  overflow: hidden;
  color: #334155;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-source-summary button {
  margin-top: 3px;
  color: #2563eb;
  font-size: 9px;
  font-weight: 700;
}

.content-source-summary .content-source-image-preview {
  position: relative;
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  overflow: hidden;
  margin-top: 0;
  border-radius: 6px;
  color: #fff;
}

.content-source-summary .content-source-image-preview img {
  width: 100%;
  height: 100%;
}

.content-source-image-preview > span,
.content-video-source-preview > span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.55);
  color: #fff;
  opacity: 0;
  transition: opacity 140ms ease;
}

.content-source-image-preview:hover > span,
.content-source-image-preview:focus-visible > span,
.content-video-source-preview:hover > span,
.content-video-source-preview:focus-visible > span {
  opacity: 1;
}

.content-source-image-preview:focus-visible,
.content-video-source-preview:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}

.content-video-source-roster {
  display: grid;
  gap: 6px;
  margin-top: 8px;
}

.content-video-source-roster li {
  display: grid;
  min-height: 42px;
  grid-template-columns: 42px 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 5px 7px;
  color: #94a3b8;
  font-size: 9px;
}

.content-video-source-roster li.is-ready {
  border-style: solid;
  border-color: #bfdbfe;
  background: #f8fbff;
  color: #334155;
}

.content-video-source-roster img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  object-fit: cover;
}

.content-video-source-roster strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-video-source-roster button {
  color: #dc2626;
  font-weight: 800;
}

.content-video-source-roster .content-video-source-preview {
  position: relative;
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 5px;
  color: #fff;
}

.content-video-source-roster .content-video-source-preview img {
  width: 100%;
  height: 100%;
}

.content-source-image-preview:disabled,
.content-video-source-preview:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.content-dashed-button {
  width: 100%;
  min-height: 39px;
  margin-top: 8px;
  border: 1px dashed #93c5fd;
  border-radius: 8px;
  color: #1d4ed8;
  font-size: 10px;
  font-weight: 700;
}

.content-cost-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 15px;
  border-top: 1px solid #edf1f5;
  padding-top: 13px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.content-cost-row strong {
  color: #172033;
  font-size: 13px;
}

.content-job-status {
  margin-top: 13px;
  border-radius: 9px;
  background: #eff6ff;
  padding: 10px;
}

.content-job-status > div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #1e3a8a;
  font-size: 9px;
}

.content-job-status strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-progress-track {
  height: 5px;
  overflow: hidden;
  margin-top: 8px;
  border-radius: 999px;
  background: #dbeafe;
}

.content-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #2563eb;
}

.content-job-status button {
  margin-top: 7px;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 700;
}

.content-intensity-batch-status {
  margin-top: 13px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #f8fbff;
  padding: 11px;
}

.content-intensity-batch-header,
.content-intensity-batch-header > div,
.content-intensity-batch-rows li,
.content-intensity-batch-actions {
  display: flex;
  align-items: center;
}

.content-intensity-batch-header {
  justify-content: space-between;
  gap: 8px;
  color: #64748b;
  font-size: 9px;
}

.content-intensity-batch-header > div {
  gap: 7px;
}

.content-intensity-batch-header strong {
  color: #1d4ed8;
  font-size: 12px;
}

.content-intensity-batch-rows {
  display: grid;
  gap: 5px;
  margin-top: 10px;
}

.content-intensity-batch-rows li {
  display: grid;
  grid-template-columns: 42px 1fr auto auto;
  gap: 6px;
  color: #64748b;
  font-size: 9px;
}

.content-intensity-batch-rows strong {
  color: #334155;
}

.content-intensity-batch-rows em {
  color: #dc2626;
  font-style: normal;
  font-weight: 700;
}

.content-intensity-batch-rows small {
  color: #1d4ed8;
  font-weight: 800;
}

.content-intensity-batch-actions {
  gap: 7px;
  margin-top: 10px;
}

.content-intensity-batch-actions button {
  min-height: 32px;
  flex: 1;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  background: #fff;
  color: #1d4ed8;
  font-size: 9px;
  font-weight: 800;
}

.content-intensity-batch-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.content-generate-button {
  display: inline-flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  border-radius: 9px;
  background: #1d4ed8;
  padding: 0 12px;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  box-shadow: 0 6px 14px rgba(29, 78, 216, 0.17);
}

.content-generate-button:hover {
  background: #1e40af;
}

.content-generate-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

@media (min-width: 1280px) and (max-width: 1799px) and (max-height: 1000px) {
  :host {
    overflow-x: clip;
  }
  .content-notebook-scale {
    width: 111.111111%;
    max-width: none;
    transform: scale(0.9);
    transform-origin: top left;
  }
}
@media (max-width: 1439px) {
  .content-workbench-grid {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 310px);
  }
}
@media (max-width: 1279px) {
  .content-workbench-grid {
    grid-template-columns: 1fr;
  }
  .content-settings-panel {
    position: static;
  }
  .content-settings-form {
    display: grid;
    grid-template-columns: minmax(220px, 0.8fr) minmax(220px, 1fr) minmax(260px, 1fr);
  }
  .content-settings-header {
    grid-column: 1/-1;
  }
  .content-settings-section {
    border-top: 1px solid #e8edf3;
    border-right: 1px solid #e8edf3;
  }
  .content-settings-section:last-child {
    border-right: 0;
  }
}
@media (max-width: 1023px) {
  .content-settings-form {
    grid-template-columns: 1fr;
  }
  .content-settings-section {
    border-right: 0;
  }
}
@media (max-width: 767px) {
  .content-preview-header,
  .content-selected-asset-heading,
  .content-overview {
    align-items: flex-start;
    flex-direction: column;
  }
  .content-overview > p {
    text-align: left;
  }
  .content-preview-actions,
  .content-asset-actions {
    width: 100%;
    justify-content: stretch;
  }
  .content-preview-actions button {
    flex: 1;
  }
  .content-master-media {
    aspect-ratio: 4/3;
    margin-inline: 14px;
  }
  .content-thumbnail-strip,
  .content-selected-asset {
    margin-inline: 14px;
  }
  .content-asset-detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px 0;
  }
  .content-asset-detail-grid > div:nth-child(2) {
    border-right: 0;
  }
  .content-settings-form {
    display: block;
  }
  .content-settings-section {
    border-right: 0;
  }
  .content-model-filter {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 479px) {
  .content-media-tabs {
    padding-inline: 8px;
  }
  .content-preview-actions {
    flex-direction: column;
  }
  .content-preview-actions button {
    width: 100%;
  }
  .content-thumbnail-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .content-asset-detail-grid {
    grid-template-columns: 1fr;
  }
  .content-asset-detail-grid > div {
    border-right: 0;
    border-bottom: 1px solid #edf1f5;
    padding: 0 0 10px;
  }
  .content-asset-detail-grid > div:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  :host * {
    scroll-behavior: auto;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}`],
})
export class PageContentComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public searching: boolean = false;
    public submitting: boolean = false;
    public videoSubmitting: boolean = false;
    public actionJobId: string = '';
    public accessDenied: boolean = false;
    public errorMessage: string = '';
    public csrfTokenValue: string = '';
    public searchError: string = '';
    public patients: any[] = [];
    public templates: any[] = [];
    public jobs: any[] = [];
    public assets: any[] = [];
    public selectedAsset: any = null;
    public selectedReviewAssetId: string = '';
    public confirmedReviewAssetId: string = '';
    public progressJobId: string = '';
    public selectedVideoSource: any = null;
    public selectedAudioSource: any = null;
    public selectedReferenceCondition: any = null;
    public referenceConditionPreviewOpen: boolean = false;
    public referenceRecommendations: any[] = [];
    public referenceRecommendationState: string = 'idle';
    public referenceRecommendationLoading: boolean = false;
    public referenceRecommendationError: string = '';
    public capabilities: any = { image_to_video: false };
    public generationModelAvailability: any = {};
    public imageCandidateCount: number = 3;
    public imageGenerationScope: 'single' | 'all' = 'single';
    public latestImageCostBatchId: string = '';
    public latestIntensityBatchId: string = '';
    public latestImageCostModelKey: string = '';
    public latestImageCostCandidateCount: number = 0;
    public readonly imageCandidateCountOptions: number[] = [1, 2, 3, 4, 5];
    public readonly intensityOptions: number[] = [1, 2, 3, 4, 5];
    public intensityBatchAction: boolean = false;
    public videoIdempotencyKey: string = '';
    public videoGenerationScope: 'single' | 'all' = 'single';
    public selectedIntensityVideoSources: { [key: number]: any } = {};
    public latestVideoBatchId: string = '';
    public videoBatchAction: boolean = false;
    public videoDurationSeconds: number = 3;
    public readonly videoDurationOptions: number[] = [3, 5, 7, 10, 15, 20];
    public readonly generationModelOptions: any = {
        image: [
            { value: 'openai-gpt-image-2', label: 'OpenAI · GPT Image 2' },
            { value: 'kling-image-2-1', label: 'Kling AI · Image 2.1' },
            { value: 'evolink-seedream-5-lite', label: 'EvoLink · Seedream 5.0 Lite' }
        ],
        video: [
            { value: 'kling-video-3', label: 'Kling AI · Video 3.0' },
            { value: 'evolink-seedance-2-5', label: 'EvoLink · Seedance 2.5' },
            { value: 'wan-2-2', label: 'ComfyUI · Wan 2.2' }
        ]
    };
    public selectedGenerationModelKeys: any = {
        image: 'openai-gpt-image-2',
        video: 'kling-video-3'
    };
    public selectedVideoResultModelKey: string = 'all';
    public metrics: any = {};
    public videoMetrics: any = {};
    public imagePricing: any = { currency: 'USD', estimated: true, models: {} };
    public videoPricing: any = { currency: 'USD', estimated: true, models: {} };
    public filters: any = { text: '', status: '', media_type: '' };
    public page: number = 1;
    public dump: number = 20;
    public total: number = 0;
    public form: any = { patient_id: '', scenario_type: '', media_type: 'image', intensity: 1, idempotency_key: '' };
    public promptSelectionMode: 'auto' | 'manual' | 'source' | '' = '';
    public promptMismatchAcknowledged: boolean = false;
    public settingsAccordion: 'prompt' | 'reference' | 'intensity' | 'generation' | '' = 'prompt';
    public mediaTypes: any[] = [
        { value: 'image', label: '이미지', help: '정지 장면과 단계별 시각 노출 자료를 생성합니다.' },
        { value: 'audio', label: '오디오', help: '환경음과 공간 음향 기반 노출 자료를 생성합니다.' },
        { value: 'video', label: '비디오', help: '시간 흐름이 있는 짧은 장면 기반 노출 자료를 생성합니다.' }
    ];
    public scenarios: any[] = [];
    public statusOptions: any[] = [
        { value: '', label: '전체 상태' },
        { value: 'queued', label: '대기' },
        { value: 'running', label: '생성 중' },
        { value: 'postprocessing', label: '후처리' },
        { value: 'review_pending', label: '생성 완료' },
        { value: 'approved', label: '승인' },
        { value: 'rejected', label: '반려' },
        { value: 'failed', label: '실패' },
        { value: 'cancelled', label: '취소' },
        { value: 'quarantined', label: '격리' }
    ];

    private pollTimer: any = null;
    private destroyed: boolean = false;
    private polling: boolean = false;
    private previewRefreshAttempts: { [key: string]: number } = {};
    private referenceImageErrors: { [key: string]: boolean } = {};
    private previewReturnFocus: HTMLElement | null = null;
    private referencePreviewReturnFocus: HTMLElement | null = null;
    private progressReturnFocus: HTMLElement | null = null;
    private routeSub: any = null;
    private requestedPatientId: string = '';
    private requestedPatientParameterPresent: boolean = false;
    private searchSequence: number = 0;
    private readonly generationReferenceStorageKey = 'ptsd.referenceGenerationCondition.v1';
    private readonly contentPatientStorageKey = 'ptsd.contentPatientSelection.v1';

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef    )         private changeDetector: ChangeDetectorRef    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');

        if (!this.can('content.read')) {
            this.accessDenied = true;
            this.loading = false;
            await this.service.render();
            return;
        }

        this.routeSub = this.route.queryParamMap.subscribe((params) => {
            if (params.get('reference_condition') === '1') {
                this.consumeReferenceGenerationCondition();
            }
            const routePatientParameterPresent = params.has('patient_id');
            const routePatientId = this.normalizeRequestedPatientId(
                params.get('patient_id')
            );
            const rememberedPatientId = routePatientParameterPresent
                ? ''
                : this.rememberedContentPatientId();
            this.requestedPatientId = routePatientId || rememberedPatientId;
            this.requestedPatientParameterPresent = (
                routePatientParameterPresent || !!rememberedPatientId
            );
            if (routePatientParameterPresent) {
                this.rememberContentPatientId(routePatientId);
            }
            if (this.loading) return;
            const previousPatientId = String(this.form.patient_id || '');
            this.applyDefaults();
            if (previousPatientId !== String(this.form.patient_id || '')) {
                this.form.idempotency_key = this.newIdempotencyKey();
                this.videoIdempotencyKey = this.newIdempotencyKey();
                this.clearPatientContent();
                void this.search(true);
                void this.loadReferenceRecommendations();
            }
            void this.service.render();
        });
        await this.bootstrap();
        this.startPolling();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        if (this.pollTimer) {
            window.clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
        if (this.routeSub) {
            this.routeSub.unsubscribe();
            this.routeSub = null;
        }
        this.referencePreviewReturnFocus = null;
        document.body.style.overflow = '';
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    private normalizedReferenceCondition(value: any) {
        if (!value || typeof value !== 'object') return null;
        const referenceId = String(value?.reference_id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(referenceId)) return null;
        return {
            schema_version: 1,
            reference_id: referenceId,
            title: String(value?.title || '').slice(0, 255),
            source_label: String(value?.source_label || '').slice(0, 120),
            era_bucket: String(value?.era_bucket || '').slice(0, 32),
            era_label: String(value?.era_label || '').slice(0, 80),
            region: String(value?.region || '').slice(0, 80),
            district: String(value?.district || '').slice(0, 80),
            category: String(value?.category || '').slice(0, 120),
            tags: Array.isArray(value?.tags)
                ? value.tags.map((item: any) => String(item || '').slice(0, 80)).filter(Boolean).slice(0, 30)
                : [],
            semantic_tags: Array.isArray(value?.semantic_tags)
                ? value.semantic_tags.map((item: any) => String(item || '').slice(0, 80)).filter(Boolean).slice(0, 32)
                : [],
            preview_thumbnail_url: this.publicReferenceImageUrl(
                value?.preview_thumbnail_url
            ),
            preview_image_url: this.publicReferenceImageUrl(
                value?.preview_image_url
            ),
            original_image_transmitted: false
        };
    }

    private consumeReferenceGenerationCondition() {
        let parsed: any = null;
        try {
            const raw = window.sessionStorage.getItem(
                this.generationReferenceStorageKey
            );
            parsed = raw ? JSON.parse(raw) : null;
            window.sessionStorage.removeItem(this.generationReferenceStorageKey);
        } catch (_error) {
            try {
                window.sessionStorage.removeItem(this.generationReferenceStorageKey);
            } catch (_ignored) {
            }
        }
        const condition = this.normalizedReferenceCondition(parsed);
        if (!condition) return;
        this.selectedReferenceCondition = condition;
        this.form.media_type = 'image';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
    }

    public async clearReferenceGenerationCondition() {
        if (this.referenceConditionPreviewOpen) {
            await this.closeReferenceConditionPreview();
        }
        this.selectedReferenceCondition = null;
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        try {
            window.sessionStorage.removeItem(this.generationReferenceStorageKey);
        } catch (_error) {
        }
        await this.service.render();
    }

    private publicReferenceImageUrl(value: any) {
        const url = String(value || '').trim().slice(0, 1000);
        if (!/^https?:\/\//i.test(url)) return '';
        try {
            const parsed = new URL(url);
            return ['http:', 'https:'].includes(parsed.protocol) ? url : '';
        } catch (_error) {
            return '';
        }
    }

    private referenceImageAvailable(url: string) {
        return !!url && this.referenceImageErrors[url] !== true;
    }

    public referenceConditionThumbnailUrl() {
        const thumbnail = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_thumbnail_url
        );
        const image = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_image_url
        );
        if (this.referenceImageAvailable(thumbnail)) return thumbnail;
        return this.referenceImageAvailable(image) ? image : '';
    }

    public referenceConditionFullImageUrl() {
        const image = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_image_url
        );
        const thumbnail = this.publicReferenceImageUrl(
            this.selectedReferenceCondition?.preview_thumbnail_url
        );
        if (this.referenceImageAvailable(image)) return image;
        return this.referenceImageAvailable(thumbnail) ? thumbnail : '';
    }

    public async onReferenceConditionImageError(url: string) {
        const normalized = this.publicReferenceImageUrl(url);
        if (normalized) this.referenceImageErrors[normalized] = true;
        if (!this.referenceConditionFullImageUrl()) {
            this.referenceConditionPreviewOpen = false;
            document.body.style.overflow = '';
        }
        await this.service.render();
    }

    public async openReferenceConditionPreview() {
        if (!this.referenceConditionFullImageUrl()) return;
        this.referencePreviewReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.referenceConditionPreviewOpen = true;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => {
            document.getElementById('content-reference-preview-close')?.focus();
        }, 0);
    }

    public async closeReferenceConditionPreview() {
        this.referenceConditionPreviewOpen = false;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.referencePreviewReturnFocus;
        this.referencePreviewReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onReferenceConditionPreviewKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeReferenceConditionPreview();
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'content-reference-preview-dialog');
    }

    public referenceConditionRequestId(mediaType: string = this.form.media_type) {
        const normalizedMediaType = this.normalizeMediaType(mediaType);
        if (!['image', 'video'].includes(normalizedMediaType)) return '';
        const referenceId = String(
            this.selectedReferenceCondition?.reference_id || ''
        ).trim().toLowerCase();
        return /^[0-9a-f]{32}$/.test(referenceId) ? referenceId : '';
    }

    public referenceConditionSummary(value: any = this.selectedReferenceCondition) {
        if (!value) return '';
        return [
            String(value?.era_label || '').trim(),
            String(value?.region || '').trim(),
            String(value?.district || '').trim(),
            String(value?.category || '').trim()
        ].filter((item: string, index: number, items: string[]) =>
            !!item && item !== '연대 미상' && items.indexOf(item) === index
        ).join(' · ');
    }

    private referenceConditionFromRecord(record: any) {
        const candidates = [
            record?.reference_condition,
            record?.asset?.reference_condition,
            this.primaryMetadata(record)?.reference_condition
        ];
        for (const candidate of candidates) {
            const normalized = this.normalizedReferenceCondition(candidate);
            if (normalized) return normalized;
        }
        return null;
    }

    public async bootstrap() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('bootstrap', {
                patient_id: this.requestedPatientId
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '콘텐츠 워크벤치를 불러오지 못했습니다.';
                return;
            }

            const payload = data || {};
            this.csrfTokenValue = payload.csrf_token || this.csrfTokenValue;
            this.metrics = {};
            this.videoMetrics = {};
            this.imagePricing = payload?.image_pricing || { currency: 'USD', estimated: true, models: {} };
            this.videoPricing = payload?.video_pricing || { currency: 'USD', estimated: true, models: {} };
            await this.loadImagePricing();
            this.capabilities = payload?.capabilities || { image_to_video: false };
            this.generationModelAvailability = payload?.generation_model_availability || {};
            this.patients = this.extractList(payload, ['patients', 'patient_options']);
            this.templates = this.extractList(payload, ['templates', 'prompt_templates']);
            const scenarios = this.extractList(payload, ['scenarios', 'scenario_options']);
            if (scenarios.length > 0) this.scenarios = scenarios;
            else if (this.templates.length > 0) this.scenarios = this.scenarioOptionsFromTemplates();

            this.applyDefaults();
            if (
                payload?.patient_scoped === true
                && this.normalizeRequestedPatientId(this.form.patient_id)
            ) {
                const bootstrapJobs = this.extractList(
                    payload,
                    ['jobs', 'generation_jobs']
                ).filter((item: any) => this.recordMatchesSelectedPatient(item));
                const bootstrapAssets = this.extractList(
                    payload,
                    ['assets', 'artifacts', 'media_assets']
                ).filter((item: any) => this.recordMatchesSelectedPatient(item));
                this.jobs = bootstrapJobs;
                this.assets = bootstrapAssets.length > 0
                    ? bootstrapAssets
                    : this.assetsFromJobs(bootstrapJobs);
                const bootstrapMetrics = this.metricPayload(payload?.metrics);
                this.metrics = String(bootstrapMetrics?.scope || '').toLowerCase() === 'patient'
                    ? bootstrapMetrics
                    : {};
                const bootstrapVideoMetrics = this.metricPayload(payload?.video_metrics);
                this.videoMetrics = String(bootstrapVideoMetrics?.scope || '').toLowerCase() === 'patient'
                    ? bootstrapVideoMetrics
                    : {};
                this.total = this.jobs.length;
            } else {
                this.clearPatientContent();
            }
            await this.search(false);
            await this.loadReferenceRecommendations();
        } catch (error) {
            this.errorMessage = '콘텐츠 워크벤치를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private async loadImagePricing() {
        try {
            const { code, data } = await wiz
                .app('component.content_pricing_v2')
                .call('pricing');
            const pricing = data?.image_pricing;
            if (
                code === 200
                && pricing?.models
                && typeof pricing.models === 'object'
            ) this.imagePricing = pricing;
        } catch (_error) {
            // Keep the bootstrap pricing when the cache-busting API is unavailable.
        }
    }

    public async search(showLoading: boolean = true, resetPage: boolean = true) {
        if (!this.can('content.read')) return;
        const patientId = this.normalizeRequestedPatientId(this.form.patient_id);
        const requestSequence = ++this.searchSequence;
        if (resetPage) this.page = 1;
        if (showLoading) {
            this.searching = true;
            this.searchError = '';
            await this.service.render();
        }

        if (!patientId) {
            this.jobs = [];
            this.assets = [];
            this.metrics = {};
            this.videoMetrics = {};
            this.total = 0;
            this.searching = false;
            await this.service.render();
            return;
        }

        try {
            const { code, data } = await wiz.call('search', {
                patient_id: patientId,
                text: String(this.filters.text || '').trim(),
                status: this.filters.status || '',
                media_type: this.filters.media_type || '',
                page: this.page,
                dump: this.dump
            });
            if (
                requestSequence !== this.searchSequence
                || patientId !== this.normalizeRequestedPatientId(this.form.patient_id)
            ) return;

            if (code !== 200) {
                this.searchError = data?.message || '작업과 자산 목록을 불러오지 못했습니다.';
                return;
            }

            this.applySearchPayload(data);
        } catch (error) {
            if (
                requestSequence !== this.searchSequence
                || patientId !== this.normalizeRequestedPatientId(this.form.patient_id)
            ) return;
            this.searchError = '작업과 자산 목록을 불러오지 못했습니다.';
        } finally {
            if (
                requestSequence === this.searchSequence
                && patientId === this.normalizeRequestedPatientId(this.form.patient_id)
            ) {
                this.searching = false;
                await this.service.render();
            }
        }
    }

    public async createJob() {
        if (!this.can('content.write') || this.submitting) return;

        const patientId = String(this.form.patient_id || '').trim();
        const scenarioType = String(this.form.scenario_type || '').trim();
        const mediaType = this.normalizeMediaType(this.form.media_type);
        const intensity = this.normalizeIntensityValue(this.form.intensity);
        this.form.intensity = intensity;
        this.imageCandidateCount = this.normalizeCandidateCount(
            this.imageCandidateCount
        );
        const templateId = this.templateIdForScenario(scenarioType, mediaType);
        if (!this.form.idempotency_key) this.form.idempotency_key = this.newIdempotencyKey();

        if (!patientId) {
            await this.service.modal.error('비식별 환자 코드를 선택해주세요.');
            return;
        }
        if (!this.selectedPatientPromptReady()) {
            await this.service.modal.error(
                '환자 상세에서 AI 프롬프트 초안을 만들고 담당 임상의 승인을 완료해주세요.'
            );
            return;
        }
        if (!scenarioType) {
            await this.service.modal.error('사용할 프롬프트 세트를 선택해주세요.');
            return;
        }
        if (this.promptSelectionMismatch() && !this.promptMismatchAcknowledged) {
            await this.service.modal.error(
                '환자 유형과 다른 프롬프트 세트를 사용하려면 먼저 경고 내용을 확인해주세요.'
            );
            return;
        }
        if (!mediaType) {
            await this.service.modal.error('콘텐츠 유형을 선택해주세요.');
            return;
        }
        if (mediaType === 'video') {
            await this.service.modal.error('아래 자산에서 이미지를 선택한 뒤 영상 만들기를 진행해주세요.');
            return;
        }
        if (mediaType === 'image' && !this.selectedGenerationModelAvailable('image')) {
            await this.service.modal.error(this.selectedGenerationModelUnavailableMessage('image'));
            return;
        }
        if (!Number.isInteger(intensity) || intensity < 1 || intensity > 5) {
            await this.service.modal.error('강도는 1부터 5 사이에서 선택해주세요.');
            return;
        }
        if (this.templates.length > 0 && !templateId) {
            await this.service.modal.error('선택한 시나리오에 활성 Prompt 템플릿이 없습니다.');
            return;
        }

        this.submitting = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const requestPayload: any = {
                patient_id: patientId,
                scenario_type: scenarioType,
                scenario: scenarioType,
                template_id: templateId,
                media_type: mediaType,
                intensity: intensity,
                idempotency_key: this.form.idempotency_key,
                acknowledge_scenario_mismatch: (
                    this.promptSelectionMismatch()
                    && this.promptMismatchAcknowledged
                ),
                reference_id: this.referenceConditionRequestId(mediaType),
                csrf_token: this.csrfToken()
            };
            const { code, data } = mediaType === 'image'
                ? (
                    this.imageGenerationScope === 'all'
                        ? await wiz.call('create_intensity_image_batch', {
                            ...requestPayload,
                            candidate_count: this.imageCandidateCount,
                            generation_model: this.selectedGenerationModelKeys.image
                        })
                        : await wiz.call('create_image_candidates', {
                            ...requestPayload,
                            candidate_count: this.imageCandidateCount,
                            generation_model: this.selectedGenerationModelKeys.image
                        })
                )
                : await wiz.call('create_job', requestPayload);

            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message || '콘텐츠 생성 요청을 등록하지 못했습니다.';
                return;
            }

            if (mediaType === 'image') {
                const intensityBatch = this.imageGenerationScope === 'all';
                const candidateJobs = intensityBatch
                    ? this.intensityBatchJobsFromPayload(
                        data,
                        this.imageCandidateCount
                    )
                    : this.candidateJobsFromPayload(
                        data,
                        this.imageCandidateCount
                    );
                if (candidateJobs === null) {
                    this.errorMessage = '이미지 후보 생성 결과를 확인하지 못했습니다. 같은 요청으로 다시 시도해주세요.';
                    return;
                }
                this.latestIntensityBatchId = intensityBatch
                    ? String(data?.intensity_batch_id || '')
                    : '';
                this.latestImageCostBatchId = intensityBatch
                    ? ''
                    : String(candidateJobs[0]?.candidate_batch_id || '');
                this.latestImageCostModelKey = this.selectedImageModelKey();
                this.latestImageCostCandidateCount = candidateJobs.length;
                [...candidateJobs].reverse().forEach((job: any) => this.upsertJob(job, true));
            } else {
                const job = this.jobFromPayload(data);
                if (job && this.jobId(job)) this.upsertJob(job, true);
            }
            this.mergeAssets(this.assetsFromPayload(data));
            this.form.idempotency_key = this.newIdempotencyKey();
            await this.service.modal.success(
                mediaType === 'image'
                    ? (
                        this.imageGenerationScope === 'all'
                            ? `강도 1~5별 이미지 후보 ${this.imageCandidateCount}개씩, 총 ${this.imageCandidateCount * 5}개의 생성 요청을 등록했습니다.`
                            : `이미지 후보 ${this.imageCandidateCount}개의 생성 요청을 등록했습니다. 진행 상태는 자동으로 갱신됩니다.`
                    )
                    : '생성 요청을 등록했습니다. 진행 상태는 자동으로 갱신됩니다.'
            );
            await this.search(false);
        } catch (error) {
            this.errorMessage = '콘텐츠 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.submitting = false;
            await this.service.render();
        }
    }

    public selectVideoSource(asset: any) {
        if (!this.can('content.write') || !this.videoSourceEligible(asset)) return;
        if (this.isSelectedVideoSource(asset)) {
            this.selectedVideoSource = null;
            if (this.form.media_type === 'video') this.syncScenarioForSelectedPatient();
        } else {
            this.selectedVideoSource = asset;
            const inheritedReference = this.referenceConditionFromRecord(asset);
            if (inheritedReference) {
                this.selectedReferenceCondition = inheritedReference;
            }
            if (this.form.media_type === 'video') this.syncScenarioForSelectedPatient();
            this.videoIdempotencyKey = this.newIdempotencyKey();
        }
        this.selectedVideoResultModelKey = 'all';
        this.changeDetector.detectChanges();
    }

    public toggleIntensityVideoSource(asset: any) {
        if (!this.can('content.write') || !this.videoSourceEligible(asset)) return;
        const intensity = this.jobIntensity(asset);
        if (!this.intensityOptions.includes(intensity)) return;
        const current = this.selectedIntensityVideoSources[intensity];
        const next = { ...this.selectedIntensityVideoSources };
        if (current && this.assetId(current) === this.assetId(asset)) {
            delete next[intensity];
        } else {
            next[intensity] = asset;
        }
        this.selectedIntensityVideoSources = next;
        this.latestVideoBatchId = '';
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public isIntensityVideoSource(asset: any) {
        const intensity = this.jobIntensity(asset);
        return !!this.assetId(asset)
            && this.assetId(this.selectedIntensityVideoSources[intensity]) === this.assetId(asset);
    }

    public intensityVideoSourceRows() {
        return this.intensityOptions.map((intensity: number) => ({
            intensity,
            source: this.selectedIntensityVideoSources[intensity] || null
        }));
    }

    public intensityVideoSourceRevisionIds() {
        return this.intensityOptions.map(
            (intensity: number) => this.assetId(
                this.selectedIntensityVideoSources[intensity]
            )
        );
    }

    public async onVideoGenerationScopeChange(value: any) {
        this.videoGenerationScope = value === 'all' ? 'all' : 'single';
        this.latestVideoBatchId = '';
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public selectAudioSource(asset: any) {
        if (!this.can('content.write') || !this.audioSourceEligible(asset)) return;
        this.selectedAudioSource = this.isSelectedAudioSource(asset) ? null : asset;
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public isSelectedAudioSource(asset: any) {
        const selectedId = this.assetId(this.selectedAudioSource);
        return !!selectedId && selectedId === this.assetId(asset);
    }

    public audioSourceEligible(asset: any) {
        if (!asset || this.mediaType(asset) !== 'audio') return false;
        const data = this.primaryMetadata(asset);
        return String(data?.safety_status || asset?.safety_status || '').toLowerCase() === 'passed'
            && ['pending', 'approved'].includes(
                String(data?.review_status || asset?.review_status || '').toLowerCase()
            );
    }

    public isSelectedVideoSource(asset: any) {
        const selectedId = this.assetId(this.selectedVideoSource);
        return !!selectedId && selectedId === this.assetId(asset);
    }

    public videoSourceEligible(asset: any) {
        if (!asset || this.mediaType(asset) !== 'image') return false;
        if (asset.video_source_eligible === true) return true;
        const data = this.primaryMetadata(asset);
        return String(data?.provider_name || asset?.provider_name || '').toLowerCase() === 'openai'
            && String(data?.safety_status || asset?.safety_status || '').toLowerCase() === 'passed'
            && ['pending', 'approved'].includes(
                String(data?.review_status || asset?.review_status || '').toLowerCase()
            );
    }

    public videoSourceReason(asset: any) {
        const reason = String(asset?.video_source_reason || '');
        const labels: any = {
            openai_required: 'OpenAI로 생성한 이미지만 선택할 수 있습니다.',
            source_not_eligible: '안전성 검사를 통과한 생성 완료 이미지만 선택할 수 있습니다.'
        };
        return labels[reason] || '이 이미지는 영상 소스로 사용할 수 없습니다.';
    }

    public canCreateVideoFromSource() {
        if (!this.generationModelAvailable(this.selectedVideoModelKey(), 'video')) return false;
        if (!this.videoSourceEligible(this.selectedVideoSource)) return false;
        if (this.promptSelectionMismatch() && !this.promptMismatchAcknowledged) return false;
        const scenario = String(
            this.selectedVideoSource?.scenario_type
            || this.selectedVideoSource?.scenario
            || this.form.scenario_type
            || ''
        );
        return !!this.templateIdForScenario(scenario, 'video');
    }

    public selectedVideoModelKey() {
        return String(this.selectedGenerationModelKeys?.video || '');
    }

    public generationModelAvailable(modelKey: string, mediaType: string) {
        const availability = this.generationModelAvailability?.[mediaType]?.[modelKey];
        return availability?.available === true;
    }

    public selectedGenerationModelAvailable(mediaType: string) {
        const modelKey = String(this.selectedGenerationModelKeys?.[mediaType] || '');
        return this.generationModelAvailable(modelKey, mediaType);
    }

    public selectedGenerationModelStatusLabel(mediaType: string) {
        if (this.selectedGenerationModelAvailable(mediaType)) return '연결됨';
        const modelKey = String(this.selectedGenerationModelKeys?.[mediaType] || '');
        const status = String(
            this.generationModelAvailability?.[mediaType]?.[modelKey]?.status || ''
        );
        return status === 'permission_required' ? '권한 필요' : '연결 안 됨';
    }

    public selectedGenerationModelStatusClass(mediaType: string) {
        return this.selectedGenerationModelAvailable(mediaType)
            ? 'bg-emerald-50 text-emerald-700'
            : 'bg-red-50 text-red-700';
    }

    public generationModelOptionLabel(model: any, mediaType: string) {
        const label = String(model?.label || '');
        const modelKey = String(model?.value || '');
        if (this.generationModelAvailable(modelKey, mediaType)) return label;
        const status = String(
            this.generationModelAvailability?.[mediaType]?.[modelKey]?.status || ''
        );
        return status === 'permission_required'
            ? `${label} (권한 필요)`
            : `${label} (연결 안 됨)`;
    }

    public selectedGenerationModelUnavailableMessage(mediaType: string) {
        const modelKey = String(this.selectedGenerationModelKeys?.[mediaType] || '');
        return String(
            this.generationModelAvailability?.[mediaType]?.[modelKey]?.message
            || '선택한 생성 모델의 연결 상태를 확인해주세요.'
        );
    }

    public jobGenerationModelKey(job: any) {
        const mediaType = this.normalizeMediaType(job?.media_type || '');
        const provider = String(
            job?.provider_name || job?.provider || ''
        ).trim().toLowerCase();
        const routes: any = {
            'image:openai': 'openai-gpt-image-2',
            'image:kling': 'kling-image-2-1',
            'image:evolink': 'evolink-seedream-5-lite',
            'video:kling': 'kling-video-3',
            'video:evolink': 'evolink-seedance-2-5',
            'video:comfyui': 'wan-2-2'
        };
        return routes[`${mediaType}:${provider}`] || '';
    }

    public jobGenerationModelAvailable(job: any) {
        const mediaType = this.normalizeMediaType(job?.media_type || '');
        const modelKey = this.jobGenerationModelKey(job);
        return !modelKey || this.generationModelAvailable(modelKey, mediaType);
    }

    public videoDurationOptionsForSelectedModel() {
        const modelKey = this.selectedVideoModelKey();
        if (modelKey === 'evolink-seedance-2-5') return [5, 7, 10, 15, 20];
        if (modelKey === 'kling-video-3') return [3, 5, 7, 10, 15];
        return [3, 5, 7];
    }

    public selectedImageModelLabel() {
        const modelKey = String(this.selectedGenerationModelKeys?.image || '');
        const option = (this.generationModelOptions.image || []).find(
            (candidate: any) => candidate.value === modelKey
        );
        return String(option?.label || '선택한 이미지 모델');
    }

    public imageGenerationRequestNote() {
        const total = this.imageGenerationTotalCount();
        const scope = this.imageGenerationScope === 'all'
            ? `강도 1~5별 ${this.imageCandidateCount}개`
            : `현재 강도 ${this.imageCandidateCount}개`;
        return `${scope}, 총 ${total}건의 ${this.selectedImageModelLabel()} 요청이 각각 실행되며 요청별 사용 비용이 발생합니다.`;
    }

    public imageGenerationTotalCount() {
        const count = this.normalizeCandidateCount(this.imageCandidateCount);
        return count * (this.imageGenerationScope === 'all' ? 5 : 1);
    }

    public async onImageGenerationScopeChange(value: any) {
        this.imageGenerationScope = value === 'all' ? 'all' : 'single';
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        await this.service.render();
    }

    public selectedImageModelKey() {
        return String(this.selectedGenerationModelKeys?.image || '');
    }

    public selectedImagePricing() {
        const models = this.imagePricing?.models;
        if (!models || typeof models !== 'object') return null;
        const pricing = models[this.selectedImageModelKey()];
        return pricing && typeof pricing === 'object' ? pricing : null;
    }

    public imageAssetModelKey(item: any) {
        const data = this.primaryMetadata(item);
        const usage = this.generationUsage(item);
        const provider = String(
            usage?.provider_name
            || data?.provider_name
            || item?.provider_name
            || ''
        ).toLowerCase();
        const model = String(
            usage?.model_name
            || data?.model_name
            || item?.model_name
            || ''
        ).toLowerCase();
        if (provider.includes('openai') || model.includes('gpt-image')) {
            return 'openai-gpt-image-2';
        }
        if (provider.includes('kling') || model.includes('kling-v2-1') || model.includes('kling-v3')) {
            return 'kling-image-2-1';
        }
        if (provider.includes('evolink') || model.includes('seedream')) {
            return 'evolink-seedream-5-lite';
        }
        return '';
    }

    public latestSelectedImageCostPerRequest() {
        const modelKey = this.selectedImageModelKey();
        const row = (Array.isArray(this.jobs) ? this.jobs : [])
            .filter((job: any) => (
                this.mediaType(job) === 'image'
                && this.imageAssetModelKey(job) === modelKey
                && this.generationUsageAvailable(job)
                && Number(this.generationUsage(job)?.cost_micros) > 0
            ))
            .slice()
            .sort((left: any, right: any) => {
                const leftTime = Date.parse(
                    left?.completed_at || left?.updated_at || left?.created_at || ''
                ) || 0;
                const rightTime = Date.parse(
                    right?.completed_at || right?.updated_at || right?.created_at || ''
                ) || 0;
                return rightTime - leftTime;
            })[0];
        const cost = Number(this.generationUsage(row)?.cost_micros);
        return Number.isFinite(cost) && cost > 0 ? cost : null;
    }

    public selectedImageEstimatedCostMicros() {
        const pricing = this.selectedImagePricing();
        const status = String(pricing?.pricing_status || '').toLowerCase();
        const count = this.imageGenerationTotalCount();
        const configuredRate = Number(pricing?.cost_micros_per_image);
        if (
            status === 'configured'
            && Number.isFinite(configuredRate)
            && configuredRate > 0
        ) return configuredRate * count;

        const observedRate = this.latestSelectedImageCostPerRequest();
        if (observedRate) return observedRate * count;

        const estimateRate = Number(pricing?.estimate_micros_per_image);
        return Number.isFinite(estimateRate) && estimateRate > 0
            ? estimateRate * count
            : null;
    }

    public selectedImageActualCostMicros() {
        const batchId = String(this.latestImageCostBatchId || '');
        const intensityBatchId = String(this.latestIntensityBatchId || '');
        const modelKey = String(this.latestImageCostModelKey || '');
        const expectedCount = Number(this.latestImageCostCandidateCount || 0);
        if (
            (!batchId && !intensityBatchId)
            || modelKey !== this.selectedImageModelKey()
            || !Number.isInteger(expectedCount)
            || expectedCount < 1
        ) return null;

        const batch = (Array.isArray(this.jobs) ? this.jobs : []).filter(
            (job: any) => intensityBatchId
                ? String(job?.intensity_batch_id || '') === intensityBatchId
                : String(job?.candidate_batch_id || '') === batchId
        );
        if (batch.length !== expectedCount) return null;
        const actualCosts = batch.map((job: any) => {
            const usage = this.generationUsage(job);
            const status = String(usage?.pricing_status || '').toLowerCase();
            const cost = Number(usage?.cost_micros);
            if (
                !this.generationUsageAvailable(job)
                || ['unpriced', 'unpriced_legacy'].includes(status)
                || !Number.isFinite(cost)
                || cost <= 0
            ) return null;
            return cost;
        });
        if (actualCosts.some((cost: number | null) => cost === null)) return null;
        return actualCosts.reduce(
            (total: number, cost: number | null) => total + Number(cost || 0),
            0
        );
    }

    public selectedImageCostTitle() {
        return this.selectedImageActualCostMicros() !== null
            ? '이번 생성 실제 비용'
            : '선택 기준 예상 비용';
    }

    public selectedImageEstimatedCostLabel() {
        const actualMicros = this.selectedImageActualCostMicros();
        if (actualMicros !== null) return this.formatCost(actualMicros);

        const micros = this.selectedImageEstimatedCostMicros();
        if (micros !== null) {
            const prefix = this.selectedImageModelKey() === 'kling-image-2-1'
                ? '약 '
                : '';
            return prefix + this.formatCost(micros);
        }

        const status = String(
            this.selectedImagePricing()?.pricing_status || ''
        ).toLowerCase();
        if (status === 'usage_based') return '토큰 사용량 기준';
        if (status === 'provider_reported') return '공급사 응답 후 계산';
        return '요금 확인 필요';
    }

    public selectedImageEstimatedCostDetail() {
        const pricing = this.selectedImagePricing();
        const count = this.imageGenerationTotalCount();
        const model = this.selectedImageModelLabel();
        const resolution = String(pricing?.resolution || '').trim();
        const quality = String(pricing?.quality || '').trim();
        const status = String(pricing?.pricing_status || '').toLowerCase();
        const configuredRate = Number(pricing?.cost_micros_per_image);
        const observedRate = this.latestSelectedImageCostPerRequest();
        const estimateRate = Number(pricing?.estimate_micros_per_image);
        const actualMicros = this.selectedImageActualCostMicros();
        const parts = [model, resolution, quality].filter(
            (value: string) => !!value
        );

        if (actualMicros !== null) {
            parts.push(`${this.latestImageCostCandidateCount}개 실제 청구 합계`);
            parts.push('공급사 청구 응답 기준');
        } else if (
            status === 'configured'
            && Number.isFinite(configuredRate)
            && configuredRate > 0
        ) {
            parts.push(`1개당 ${this.formatCost(configuredRate)} × ${count}개`);
        } else if (observedRate) {
            parts.push(`최근 동일 모델 1건 비용 × ${count}개`);
            parts.push('실제 청구액은 달라질 수 있음');
        } else if (Number.isFinite(estimateRate) && estimateRate > 0) {
            parts.push(`예상 1개당 ${this.formatCost(estimateRate)} × ${count}개`);
            parts.push('작업 완료 후 실제 청구액으로 교체');
        } else if (status === 'usage_based') {
            parts.push('실제 입력·출력 토큰 사용량으로 확정');
        } else if (status === 'provider_reported') {
            parts.push('작업 완료 후 공급사 청구 응답으로 확정');
        } else {
            parts.push('운영 요율 설정 필요');
        }
        return parts.join(' · ');
    }

    private clearLatestImageCostBatch() {
        this.latestImageCostBatchId = '';
        this.latestIntensityBatchId = '';
        this.latestImageCostModelKey = '';
        this.latestImageCostCandidateCount = 0;
    }

    public async onImageCandidateCountChange() {
        this.imageCandidateCount = this.normalizeCandidateCount(
            this.imageCandidateCount
        );
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        await this.service.render();
    }

    public async onGenerationModelChange(mediaType: string) {
        if (mediaType === 'image') {
            this.clearLatestImageCostBatch();
            this.form.idempotency_key = this.newIdempotencyKey();
            await this.service.render();
            return;
        }
        if (mediaType !== 'video') return;
        const options = this.videoDurationOptionsForSelectedModel();
        if (!options.includes(this.videoDurationSeconds)) {
            this.videoDurationSeconds = options[0];
        }
        this.selectedVideoResultModelKey = 'all';
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public async onVideoDurationChange() {
        const options = this.videoDurationOptionsForSelectedModel();
        if (!options.includes(this.videoDurationSeconds)) {
            this.videoDurationSeconds = options[0];
        }
        this.selectedVideoResultModelKey = 'all';
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public selectedVideoPricing() {
        const models = this.videoPricing?.models;
        if (!models || typeof models !== 'object') return null;
        const pricing = models[this.selectedVideoModelKey()];
        return pricing && typeof pricing === 'object' ? pricing : null;
    }

    public selectedVideoEstimatedCostLabel() {
        const pricing = this.selectedVideoPricing();
        const status = String(pricing?.pricing_status || '').toLowerCase();
        if (status === 'no_charge') return '별도 API 과금 없음';
        if (status !== 'configured') return '요금 확인 필요';
        const estimates = pricing?.estimated_costs_micros;
        const micros = Number(estimates?.[String(this.videoDurationSeconds)]);
        const total = micros * (this.videoGenerationScope === 'all' ? 5 : 1);
        return Number.isFinite(total) ? this.formatCost(total) : '요금 확인 필요';
    }

    public selectedVideoEstimatedCostDetail() {
        const pricing = this.selectedVideoPricing();
        const model = (this.generationModelOptions.video || []).find(
            (option: any) => option.value === this.selectedVideoModelKey()
        );
        const parts = [
            String(model?.label || '').trim(),
            String(pricing?.resolution || '').trim(),
            `${this.videoDurationSeconds}초 기준`,
            this.videoGenerationScope === 'all' ? '강도별 5건 합계' : '단일 영상'
        ].filter((value: string) => !!value);
        return parts.join(' · ');
    }

    public selectedVideoModelSupportsUploadedAudio() {
        return this.selectedVideoModelKey() === 'wan-2-2';
    }

    public canCreateIntensityVideoBatch() {
        if (!this.can('content.write') || this.videoSubmitting) return false;
        if (!this.selectedGenerationModelAvailable('video')) return false;
        const sources = this.intensityVideoSourceRows().map((row: any) => row.source);
        if (sources.some((source: any) => !this.videoSourceEligible(source))) return false;
        const ids = sources.map((source: any) => this.assetId(source));
        if (ids.some((id: string) => !id) || new Set(ids).size !== 5) return false;
        const scenarios = new Set(sources.map((source: any) => String(
            source?.scenario_type || source?.scenario || ''
        ).trim()));
        if (scenarios.size !== 1 || scenarios.has('')) return false;
        const scenario = String(sources[0]?.scenario_type || sources[0]?.scenario || '');
        if (!this.templateIdForScenario(scenario, 'video')) return false;
        if (this.promptSelectionMismatch(scenario) && !this.promptMismatchAcknowledged) return false;
        return !(this.selectedAudioSource && !this.selectedVideoModelSupportsUploadedAudio());
    }

    public canCreateSelectedVideo() {
        return this.videoGenerationScope === 'all'
            ? this.canCreateIntensityVideoBatch()
            : this.canCreateVideoFromSource();
    }

    public async createSelectedVideo() {
        if (this.videoGenerationScope === 'all') {
            await this.createIntensityVideoBatch();
            return;
        }
        await this.createVideoFromSelectedImage();
    }

    public async createIntensityVideoBatch() {
        if (!this.can('content.write') || this.videoSubmitting) return;
        if (!this.canCreateIntensityVideoBatch()) {
            await this.service.modal.error(
                '강도 1~5에서 영상으로 만들 이미지 후보를 하나씩 선택해주세요.'
            );
            return;
        }
        const sources = this.intensityVideoSourceRows().map((row: any) => row.source);
        const scenario = String(
            sources[0]?.scenario_type || sources[0]?.scenario || ''
        ).trim();
        const templateId = this.templateIdForScenario(scenario, 'video');
        if (!this.videoIdempotencyKey) this.videoIdempotencyKey = this.newIdempotencyKey();

        this.videoSubmitting = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('create_intensity_video_batch', {
                source_revision_ids: this.intensityVideoSourceRevisionIds(),
                audio_source_revision_id: this.assetId(this.selectedAudioSource),
                duration_seconds: this.videoDurationSeconds,
                generation_model: this.selectedVideoModelKey(),
                template_id: templateId,
                idempotency_key: this.videoIdempotencyKey,
                acknowledge_scenario_mismatch: (
                    this.promptSelectionMismatch(scenario)
                    && this.promptMismatchAcknowledged
                ),
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message || '강도별 영상 생성 요청을 등록하지 못했습니다.';
                return;
            }
            const jobs = this.extractList(data, ['jobs', 'generation_jobs'])
                .map((job: any) => this.jobFromPayload(job));
            const batchId = String(data?.video_batch_id || '');
            const intensities = new Set(jobs.map((job: any) => this.jobIntensity(job)));
            if (
                jobs.length !== 5
                || !/^[0-9a-f]{32}$/.test(batchId)
                || jobs.some((job: any) => String(job?.video_batch_id || '') !== batchId)
                || intensities.size !== 5
            ) {
                this.errorMessage = '강도별 영상 배치 결과를 확인하지 못했습니다. 같은 요청으로 다시 시도해주세요.';
                return;
            }
            this.latestVideoBatchId = batchId;
            [...jobs].reverse().forEach((job: any) => this.upsertJob(job, true));
            this.mergeAssets(this.assetsFromPayload(data));
            this.videoIdempotencyKey = this.newIdempotencyKey();
            await this.service.modal.success(
                '강도 1~5 이미지 기반 영상 5개의 생성 요청을 등록했습니다.'
            );
            await this.search(false);
        } catch (_error) {
            this.errorMessage = '강도별 영상 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.videoSubmitting = false;
            await this.service.render();
        }
    }

    public async createVideoFromSelectedImage() {
        if (!this.can('content.write') || this.videoSubmitting) return;
        if (!this.selectedGenerationModelAvailable('video')) {
            await this.service.modal.error(this.selectedGenerationModelUnavailableMessage('video'));
            return;
        }
        const source = this.selectedVideoSource;
        if (!this.videoSourceEligible(source)) {
            await this.service.modal.error('영상으로 만들 수 있는 OpenAI 이미지를 먼저 선택해주세요.');
            return;
        }
        const sourceRevisionId = this.assetId(source);
        const scenario = String(
            source?.scenario_type
            || source?.scenario
            || this.form.scenario_type
            || ''
        );
        const templateId = this.templateIdForScenario(scenario, 'video');
        if (!sourceRevisionId || !templateId) {
            await this.service.modal.error('선택한 이미지에 맞는 비디오 템플릿이 없습니다.');
            return;
        }
        if (this.promptSelectionMismatch(scenario) && !this.promptMismatchAcknowledged) {
            await this.service.modal.error(
                '환자 유형과 다른 프롬프트 세트를 사용하려면 먼저 경고 내용을 확인해주세요.'
            );
            return;
        }
        if (this.selectedAudioSource && !this.selectedVideoModelSupportsUploadedAudio()) {
            await this.service.modal.error(
                '선택한 외부 영상 모델은 업로드 오디오 입력을 지원하지 않습니다. 오디오를 제거하거나 Wan 2.2를 선택해주세요.'
            );
            return;
        }
        if (!this.videoIdempotencyKey) this.videoIdempotencyKey = this.newIdempotencyKey();

        this.videoSubmitting = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('create_video_from_image', {
                source_revision_id: sourceRevisionId,
                audio_source_revision_id: this.assetId(this.selectedAudioSource),
                duration_seconds: this.videoDurationSeconds,
                generation_model: this.selectedVideoModelKey(),
                template_id: templateId,
                idempotency_key: this.videoIdempotencyKey,
                acknowledge_scenario_mismatch: (
                    this.promptSelectionMismatch(scenario)
                    && this.promptMismatchAcknowledged
                ),
                reference_id: this.referenceConditionRequestId('video'),
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                this.errorMessage = data?.message || '선택한 이미지의 영상 생성 요청을 등록하지 못했습니다.';
                return;
            }
            const job = this.jobFromPayload(data);
            if (job && this.jobId(job)) this.upsertJob(job, true);
            this.videoIdempotencyKey = this.newIdempotencyKey();
            await this.service.modal.success('선택한 이미지의 영상 생성 요청을 등록했습니다.');
            await this.search(false);
        } catch (error) {
            this.errorMessage = '선택한 이미지의 영상 생성 요청을 등록하지 못했습니다.';
        } finally {
            this.videoSubmitting = false;
            await this.service.render();
        }
    }

    public canLinkToTherapySession(asset: any) {
        if (!this.can('sessions.operate') || !this.assetId(asset)) return false;
        const reviewStatus = this.assetReviewStatus(asset);
        return ['pending', 'review_pending', 'approved'].includes(reviewStatus)
            && this.assetSafetyStatus(asset) === 'passed';
    }

    public therapySessionLinkReason(asset: any) {
        if (this.assetSafetyStatus(asset) !== 'passed') {
            return '안전성 검사를 통과한 자산만 치료 세션에 연결할 수 있습니다.';
        }
        if (!['pending', 'review_pending', 'approved'].includes(this.assetReviewStatus(asset))) {
            return '격리·반려된 자산은 치료 세션에 연결할 수 없습니다.';
        }
        return '치료 세션에 연결할 수 없는 자산입니다.';
    }

    public async linkToTherapySession(asset: any) {
        if (!this.canLinkToTherapySession(asset)) {
            await this.service.modal.error(this.therapySessionLinkReason(asset));
            return;
        }
        const patientId = this.normalizeRequestedPatientId(
            asset?.patient_id
            || asset?.patient?.id
            || this.primaryMetadata(asset)?.patient_id
            || this.form.patient_id
        );
        const revisionId = this.assetId(asset);
        if (!patientId || !revisionId) {
            await this.service.modal.error('연결할 환자와 자산 정보를 확인해주세요.');
            return;
        }
        await this.router.navigate(['/sessions'], {
            queryParams: {
                patient_id: patientId,
                asset_revision_id: revisionId,
                media_type: this.mediaType(asset)
            }
        });
    }

    public async cancelJob(job: any) {
        const id = this.jobId(job);
        if (!this.can('content.write') || !id || !this.canCancel(job) || this.actionJobId) return;

        const confirmed = await this.service.modal.show({
            title: '생성 작업 취소',
            message: '대기 또는 처리 중인 작업을 취소하시겠습니까?',
            action: '작업 취소',
            cancel: '계속 진행',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('cancel_job', {
                job_id: id,
                csrf_token: this.csrfToken()
            });
            if (![200, 202].includes(code)) {
                await this.service.modal.error(data?.message || '작업을 취소하지 못했습니다.');
                return;
            }
            const updated = this.jobFromPayload(data);
            if (updated && this.jobId(updated)) this.upsertJob(updated);
            else await this.refreshJob(id);
        } catch (error) {
            await this.service.modal.error('작업을 취소하지 못했습니다.');
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public async retryJob(job: any) {
        const id = this.jobId(job);
        if (!this.can('content.write') || !id || !this.canRetry(job) || this.actionJobId) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('retry_job', {
                job_id: id,
                csrf_token: this.csrfToken()
            });
            if (![200, 201, 202].includes(code)) {
                await this.service.modal.error(data?.message || '작업을 다시 시도하지 못했습니다.');
                return;
            }
            const updated = this.jobFromPayload(data);
            if (updated && this.jobId(updated)) this.upsertJob(updated, true);
            await this.service.modal.success('재시도 요청을 등록했습니다.');
            await this.search(false);
        } catch (error) {
            await this.service.modal.error('작업을 다시 시도하지 못했습니다.');
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public canRegenerateImage(item: any) {
        const reviewDecision = item?.review_decision
            || this.primaryMetadata(item)?.review_decision
            || {};
        const regenerationRequested = String(
            reviewDecision?.decision || ''
        ).toLowerCase() === 'regeneration_requested';
        const reviewStatus = String(
            item?.review_status
            || this.primaryMetadata(item)?.review_status
            || 'pending'
        ).toLowerCase();
        return this.mediaType(item) === 'image'
            && !!this.jobId(item)
            && String(
                item?.job_status || item?.status || 'review_pending'
            ).toLowerCase() !== 'approved'
            && (
                ['pending', 'review_pending'].includes(reviewStatus)
                || (reviewStatus === 'rejected' && regenerationRequested)
            );
    }

    public async regenerateImageCandidate(asset: any) {
        const id = this.jobId(asset);
        if (
            !this.can('content.write')
            || !id
            || !this.canRegenerateImage(asset)
            || this.actionJobId
        ) return;

        const confirmed = await this.service.modal.show({
            title: '이미지 후보 다시 생성',
            message: '이 후보만 새로운 구도와 시점으로 다시 생성합니다. 새 결과가 성공하기 전까지 현재 이미지는 유지되며 API 사용 비용이 발생합니다.',
            action: '다시 생성',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call(
                'regenerate_image_candidate',
                {
                    job_id: id,
                    idempotency_key: this.newIdempotencyKey(),
                    csrf_token: this.csrfToken()
                }
            );
            if (![200, 201, 202].includes(code)) {
                await this.service.modal.error(
                    data?.message || '이미지 후보를 다시 생성하지 못했습니다.'
                );
                return;
            }
            const job = this.jobFromPayload(data);
            if (job && this.jobId(job)) this.upsertJob(job, true);
            this.mergeAssets(this.assetsFromPayload(data));
            await this.service.modal.success(
                '개별 이미지 재생성을 시작했습니다. 새 결과가 완료되면 현재 후보를 자동으로 교체합니다.'
            );
            await this.search(false);
        } catch (error) {
            await this.service.modal.error(
                '이미지 후보를 다시 생성하지 못했습니다.'
            );
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public async deleteJob(item: any) {
        const id = this.jobId(item);
        if (!this.can('content.write') || !id || !this.canDeleteJob(item) || this.actionJobId) return;

        const hasAsset = !!(
            item?.generation_job_id
            || item?.asset_revision_id
            || item?.revision_id
            || item?.asset?.id
        );
        const confirmed = await this.service.modal.show({
            title: hasAsset ? '생성 결과 삭제' : '생성 작업 삭제',
            message: hasAsset
                ? '이 생성 작업과 연결된 자산을 삭제하시겠습니까? 삭제한 결과는 복구할 수 없습니다.'
                : '이 생성 작업 기록을 삭제하시겠습니까? 삭제한 기록은 복구할 수 없습니다.',
            action: '삭제',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;

        this.actionJobId = id;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('delete_job', {
                job_id: id,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '생성 결과를 삭제하지 못했습니다.');
                return;
            }

            if (this.jobId(this.selectedAsset) === id) {
                this.selectedAsset = null;
                this.previewReturnFocus = null;
            }
            if (this.progressJobId === id) {
                this.progressJobId = '';
                this.progressReturnFocus = null;
            }
            if (this.jobId(this.selectedVideoSource) === id) {
                this.selectedVideoSource = null;
                this.videoIdempotencyKey = this.newIdempotencyKey();
            }
            this.jobs = this.jobs.filter((job: any) => this.jobId(job) !== id);
            this.assets = this.assets.filter((asset: any) => this.jobId(asset) !== id);
            this.total = Math.max(0, this.total - 1);
            this.page = Math.min(this.page, this.pageCount());

            await this.service.modal.success('생성 결과를 삭제했습니다.');
            await this.search(false, false);
        } catch (error) {
            await this.service.modal.error('생성 결과를 삭제하지 못했습니다.');
        } finally {
            this.actionJobId = '';
            await this.service.render();
        }
    }

    public async openPreview(asset: any) {
        if (!this.hasPlayablePreview(asset)) return;
        this.previewReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.selectedAsset = asset;
        await this.service.render();
        setTimeout(() => document.getElementById('content-preview-close')?.focus(), 0);
    }

    public async closePreview() {
        this.selectedAsset = null;
        await this.service.render();
        const target = this.previewReturnFocus;
        this.previewReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onPreviewKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closePreview();
            return;
        }
        if (event.key !== 'Tab') return;
        this.trapDialogFocus(event, 'content-preview-dialog');
    }

    private trapDialogFocus(event: KeyboardEvent, dialogId: string) {
        const dialog = document.getElementById(dialogId);
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), audio[controls], video[controls], [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public async openProgressModal(job: any = this.activeJob()) {
        const id = this.jobId(job);
        if (!id) return;
        this.progressReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.progressJobId = id;
        await this.service.render();
        setTimeout(() => document.getElementById('content-progress-close')?.focus(), 0);
    }

    public async closeProgressModal() {
        this.progressJobId = '';
        await this.service.render();
        const target = this.progressReturnFocus;
        this.progressReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onProgressKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeProgressModal();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById('content-progress-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public async onPreviewError(asset: any, failedUrl: string = '') {
        const id = this.assetId(asset) || this.jobId(asset);
        const retryKey = this.previewRefreshKey(asset, failedUrl);
        asset.preview_failed = true;
        await this.service.render();

        if (!id) return;
        if ((this.previewRefreshAttempts[retryKey] || 0) >= 1) return;
        this.previewRefreshAttempts[retryKey] = 1;

        const jobId = this.jobId(asset);
        if (jobId) await this.refreshJob(jobId, false);
        else await this.search(false, false);

        const refreshed = this.assets.find((item: any) => this.assetId(item) === this.assetId(asset));
        if (refreshed) {
            refreshed.preview_failed = false;
            if (this.selectedAsset && this.assetId(this.selectedAsset) === this.assetId(refreshed)) {
                this.selectedAsset = refreshed;
            }
        }
        await this.service.render();
    }

    public onPreviewLoaded(asset: any, loadedUrl: string = '') {
        const retryKey = this.previewRefreshKey(asset, loadedUrl);
        if (retryKey) delete this.previewRefreshAttempts[retryKey];
        if (asset) delete asset.preview_failed;
    }

    public jobId(job: any) {
        return String(job?.job_id || job?.generation_job_id || job?.id || '');
    }

    public candidateLabel(item: any) {
        const data = this.primaryMetadata(item);
        const index = Number(item?.candidate_index || data?.candidate_index || 0);
        const count = Number(item?.candidate_count || data?.candidate_count || 0);
        if (
            !Number.isInteger(index)
            || !Number.isInteger(count)
            || index < 1
            || count < 1
            || index > count
        ) return '';
        return `후보 ${index}/${count}`;
    }

    public assetId(asset: any) {
        return String(asset?.asset_revision_id || asset?.revision_id || asset?.id || asset?.asset_id || asset?.artifact_id || '');
    }

    public normalizeMediaType(value: any) {
        const mediaType = String(value || '').trim().toLowerCase();
        return ['image', 'audio', 'video'].includes(mediaType) ? mediaType : '';
    }

    public mediaType(item: any) {
        const asset = item?.asset || item?.media_asset || {};
        const artifact = this.artifacts(item)[0] || {};
        return this.normalizeMediaType(
            item?.media_type || asset?.media_type || artifact?.media_type || 'image'
        ) || 'image';
    }

    public modalityLabel(value: any) {
        const mediaType = this.normalizeMediaType(
            typeof value === 'object' ? this.mediaType(value) : value
        );
        const option = this.mediaTypes.find((item: any) => item.value === mediaType);
        return option?.label || '콘텐츠';
    }

    public mediaTypeIcon(value: any) {
        const mediaType = this.normalizeMediaType(
            typeof value === 'object' ? this.mediaType(value) : value
        );
        switch (mediaType) {
            case 'audio': return 'fa-solid fa-wave-square';
            case 'video': return 'fa-solid fa-film';
            default: return 'fa-regular fa-image';
        }
    }

    public modalityHelp(value: any) {
        const option = this.mediaTypes.find((item: any) => item.value === this.normalizeMediaType(value));
        return option?.help || '';
    }

    public modalityClass(value: any) {
        switch (this.normalizeMediaType(typeof value === 'object' ? this.mediaType(value) : value)) {
            case 'audio': return 'border-cyan-200 bg-cyan-50 text-cyan-700';
            case 'video': return 'border-violet-200 bg-violet-50 text-violet-700';
            default: return 'border-blue-200 bg-blue-50 text-blue-700';
        }
    }

    public async onMediaTypeChange() {
        this.syncScenarioForSelectedPatient();
        this.form.idempotency_key = this.newIdempotencyKey();
        await this.service.render();
    }

    public async onPatientChange() {
        this.settingsAccordion = 'prompt';
        this.syncScenarioForSelectedPatient();
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.selectedVideoSource = null;
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.clearPatientContent();
        this.requestedPatientId = this.normalizeRequestedPatientId(
            this.form.patient_id
        );
        this.rememberContentPatientId(this.requestedPatientId);
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {
                patient_id: this.requestedPatientId || null
            },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
        await this.search(true);
        await this.loadReferenceRecommendations();
    }

    public availableScenarios() {
        const mediaType = this.normalizeMediaType(this.form.media_type) || 'image';
        return this.scenarios.filter((item: any) => {
            const itemType = this.normalizeMediaType(item?.media_type || 'image') || 'image';
            return itemType === mediaType;
        });
    }

    public selectedPatientScenarioType() {
        return String(this.selectedPatientOption()?.scenario_type || '').trim();
    }

    public selectedPromptOption() {
        return this.availableScenarios().find(
            (item: any) => this.scenarioValue(item) === String(this.form.scenario_type || '')
        ) || null;
    }

    public selectedPromptTemplate() {
        const templateId = this.templateIdForScenario(
            String(this.form.scenario_type || ''),
            this.form.media_type
        );
        return this.templates.find((item: any) =>
            String(item?.id || item?.template_id || '') === String(templateId || '')
        ) || null;
    }

    public promptSelectionMismatch(value: string = this.form.scenario_type) {
        const patientScenario = this.selectedPatientScenarioType();
        const selectedScenario = String(value || '').trim();
        return !!patientScenario
            && !!selectedScenario
            && patientScenario !== selectedScenario;
    }

    public promptSelectionStatusLabel() {
        if (this.promptSelectionMode === 'source') return '원본 이미지 기준';
        if (this.promptSelectionMode === 'manual') return '직접 선택';
        return this.form.scenario_type ? '자동 권장' : '선택 필요';
    }

    public promptSetOptionLabel(option: any) {
        const label = this.scenarioOptionLabel(option);
        const version = option?.template_version || option?.version;
        const recommended = this.scenarioValue(option) === this.selectedPatientScenarioType();
        return [
            label,
            version ? `v${version}` : '',
            recommended ? '(권장)' : ''
        ].filter((value: string) => !!value).join(' · ');
    }

    public selectedPromptPositivePreview() {
        return String(
            this.selectedPromptTemplate()?.positive_prompt_preview
            || this.selectedPromptOption()?.positive_prompt_preview
            || ''
        ).trim();
    }

    public selectedPromptNegativePreview() {
        return String(
            this.selectedPromptTemplate()?.negative_prompt_preview
            || this.selectedPromptOption()?.negative_prompt_preview
            || ''
        ).trim();
    }

    public async loadReferenceRecommendations() {
        const patientId = this.normalizeRequestedPatientId(this.form.patient_id);
        this.referenceRecommendations = [];
        this.referenceRecommendationError = '';
        if (!patientId) {
            this.referenceRecommendationState = 'idle';
            this.referenceRecommendationLoading = false;
            return;
        }

        this.referenceRecommendationLoading = true;
        this.referenceRecommendationState = 'loading';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('recommended_references', {
                patient_id: patientId
            });
            if (patientId !== this.normalizeRequestedPatientId(this.form.patient_id)) {
                return;
            }
            if (code !== 200) {
                this.referenceRecommendationState = 'error';
                this.referenceRecommendationError = data?.message
                    || '추천 레퍼런스를 불러오지 못했습니다.';
                return;
            }
            this.referenceRecommendationState = String(data?.state || 'ready');
            this.referenceRecommendations = Array.isArray(data?.items)
                ? data.items.slice(0, 5)
                : [];
        } catch (_error) {
            if (patientId !== this.normalizeRequestedPatientId(this.form.patient_id)) {
                return;
            }
            this.referenceRecommendationState = 'error';
            this.referenceRecommendationError = '추천 레퍼런스를 불러오지 못했습니다.';
        } finally {
            if (patientId === this.normalizeRequestedPatientId(this.form.patient_id)) {
                this.referenceRecommendationLoading = false;
                await this.service.render();
            }
        }
    }

    public recommendedReferenceCondition(item: any) {
        return this.normalizedReferenceCondition({
            ...item,
            reference_id: item?.reference_id || item?.id
        });
    }

    public recommendedReferenceThumbnail(item: any) {
        return this.publicReferenceImageUrl(
            item?.preview_thumbnail_url || item?.preview_image_url
        );
    }

    public referenceRecommendationSummary(item: any) {
        return [
            String(item?.era_label || '').trim(),
            String(item?.region || '').trim(),
            String(item?.district || '').trim(),
            String(item?.category || '').trim()
        ].filter((value: string, index: number, values: string[]) =>
            !!value && values.indexOf(value) === index
        ).join(' · ');
    }

    public async useRecommendedReference(item: any) {
        const condition = this.recommendedReferenceCondition(item);
        if (!condition) {
            await this.service.modal.error('추천 레퍼런스 정보를 확인해주세요.');
            return;
        }
        this.selectedReferenceCondition = condition;
        this.form.media_type = 'image';
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public selectedPatientPositivePreview() {
        return String(
            this.selectedPatientOption()?.approved_positive_prompt_preview || ''
        ).trim();
    }

    public selectedPatientNegativePreview() {
        return String(
            this.selectedPatientOption()?.approved_negative_prompt_preview || ''
        ).trim();
    }

    public async onPromptSetChange(value: any) {
        const next = String(value || '').trim();
        const previous = String(this.form.scenario_type || '').trim();
        if (next === previous) return;

        const available = this.availableScenarios().some(
            (item: any) => this.scenarioValue(item) === next
        );
        if (next && !available) {
            await this.service.modal.error('현재 콘텐츠 유형에 사용할 수 없는 프롬프트 세트입니다.');
            await this.service.render();
            return;
        }

        const sourceScenario = this.form.media_type === 'video'
            ? String(
                this.selectedVideoSource?.scenario_type
                || this.selectedVideoSource?.scenario
                || ''
            ).trim()
            : '';
        if (next && sourceScenario && next !== sourceScenario) {
            await this.service.modal.warning(
                '영상 프롬프트 세트는 선택한 원본 이미지의 생성 계보와 같아야 합니다. 다른 세트를 사용하려면 먼저 해당 세트로 이미지를 생성해주세요.',
                false,
                '확인'
            );
            await this.service.render();
            return;
        }

        const mismatch = this.promptSelectionMismatch(next);
        if (mismatch) {
            const confirmed = await this.service.modal.show({
                title: '환자 유형과 다른 프롬프트 세트',
                message: `환자 유형은 '${this.scenarioLabel(this.selectedPatientScenarioType())}'이지만 '${this.scenarioLabel(next)}' 세트를 선택했습니다. 환자별 승인 프롬프트에 다른 공통 생성 규칙이 결합되며, 이 선택은 감사 기록에 남습니다. 계속하시겠습니까?`,
                action: '다른 세트 사용',
                cancel: '취소',
                status: 'warning',
                actionBtn: 'warning'
            });
            if (!confirmed) {
                await this.service.render();
                return;
            }
        }

        this.form.scenario_type = next;
        this.promptSelectionMode = next ? 'manual' : '';
        this.promptMismatchAcknowledged = mismatch;
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        this.selectedReviewAssetId = '';
        await this.service.render();
    }

    public async useRecommendedPromptSet() {
        const recommended = this.selectedPatientScenarioType();
        const available = this.availableScenarios().some(
            (item: any) => this.scenarioValue(item) === recommended
        );
        this.form.scenario_type = available ? recommended : '';
        this.promptSelectionMode = this.form.scenario_type ? 'auto' : '';
        this.promptMismatchAcknowledged = false;
        this.form.idempotency_key = this.newIdempotencyKey();
        this.videoIdempotencyKey = this.newIdempotencyKey();
        await this.service.render();
    }

    public patientLabel(patient: any) {
        return patient?.patient_code || patient?.code || patient?.pseudonym || '비식별 코드';
    }

    public selectedPatientOption() {
        const patientId = String(this.form.patient_id || '');
        return this.patients.find((patient: any) =>
            String(patient?.id || patient?.patient_id || '') === patientId
        ) || null;
    }

    private patientStatusFlag(value: any) {
        return value === true || value === 1 || value === '1'
            || String(value || '').trim().toLowerCase() === 'true';
    }

    public selectedPatientHasScenarioDescription() {
        return this.patientStatusFlag(
            this.selectedPatientOption()?.has_scenario_description
        );
    }

    public selectedPatientScenarioDescriptionReady() {
        return this.patientStatusFlag(
            this.selectedPatientOption()?.scenario_description_ready
        );
    }

    public selectedPatientPromptReady() {
        return this.patientStatusFlag(
            this.selectedPatientOption()?.scenario_prompt_ready
        );
    }

    public selectedPatientSetupState() {
        if (!this.form.patient_id || !this.selectedPatientOption()) return 'idle';
        if (!this.selectedPatientHasScenarioDescription()) return 'scenario_required';
        if (!this.selectedPatientScenarioDescriptionReady()) {
            return 'scenario_review_required';
        }
        if (!this.selectedPatientPromptReady()) return 'prompt_review_required';
        return 'ready';
    }

    public selectedPatientSetupTitle() {
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required': return '환자 시나리오가 작성되지 않았습니다.';
            case 'scenario_review_required': return '환자 시나리오 검토가 필요합니다.';
            case 'prompt_review_required': return '환자별 승인 프롬프트가 없습니다.';
            default: return '';
        }
    }

    public selectedPatientSetupMessage() {
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required':
                return '환자 상세에서 시나리오를 작성해주세요. 작성 후 맞춤 프롬프트와 레퍼런스를 준비할 수 있습니다.';
            case 'scenario_review_required':
                return '작성한 시나리오의 비식별·전송 적합성 검토를 완료해주세요.';
            case 'prompt_review_required':
                return '시나리오 프롬프트를 생성하고 담당 임상의 승인을 완료해주세요.';
            default: return '';
        }
    }

    public selectedPatientSetupActionLabel() {
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required': return '환자 시나리오 작성하기';
            case 'scenario_review_required': return '환자 시나리오 검토하기';
            case 'prompt_review_required': return '프롬프트 생성·승인하기';
            default: return '환자 상세 확인';
        }
    }

    public contentSettingsReady() {
        return this.selectedPatientSetupState() === 'ready';
    }

    public settingsLockedStatusLabel() {
        switch (this.selectedPatientSetupState()) {
            case 'scenario_required': return '시나리오 작성 후 설정';
            case 'scenario_review_required': return '시나리오 검토 후 설정';
            case 'prompt_review_required': return '프롬프트 승인 후 설정';
            default: return '환자 준비 후 설정';
        }
    }

    public settingsAccordionOpen(section: string) {
        return this.contentSettingsReady() && this.settingsAccordion === section;
    }

    public settingsAccordionSummary(section: string) {
        switch (section) {
            case 'prompt':
                return this.form.scenario_type
                    ? this.scenarioLabel(this.form.scenario_type)
                    : '프롬프트 세트를 선택해주세요';
            case 'reference':
                return this.selectedReferenceCondition?.title || '선택된 레퍼런스 없음';
            case 'intensity':
                return `현재 ${Number(this.form.intensity || 1)} / 5`;
            case 'generation':
                return this.form.media_type === 'image'
                    ? `${this.selectedImageModelLabel()} · 후보 ${this.imageCandidateCount}개`
                    : `${this.modalityLabel(this.form.media_type)} 생성 옵션`;
            default:
                return '';
        }
    }

    public async toggleSettingsAccordion(section: 'prompt' | 'reference' | 'intensity' | 'generation') {
        if (!this.contentSettingsReady()) return;
        this.settingsAccordion = this.settingsAccordion === section ? '' : section;
        await this.service.render();
    }

    public selectedPatientPromptStatus() {
        return String(
            this.selectedPatientOption()?.scenario_prompt_status || 'source_not_ready'
        );
    }

    public jobPatientCode(job: any) {
        return job?.patient_code || job?.patient?.patient_code || job?.patient?.code || '비식별 환자';
    }

    public scenarioValue(option: any) {
        return typeof option === 'string' ? option : (option?.value || option?.key || option?.scenario_type || '');
    }

    public scenarioOptionLabel(option: any) {
        return typeof option === 'string' ? option : (option?.label || option?.title || option?.name || option?.key || option?.scenario_type || option?.value || '시나리오');
    }

    public scenarioDescription(option: any) {
        if (typeof option === 'string') return '';
        if (option?.description || option?.note) return option.description || option.note;
        const version = option?.version || option?.template_version;
        return version ? 'Prompt 템플릿 v' + version : '';
    }

    public selectedScenarioDescription() {
        const option = this.availableScenarios().find((item: any) => this.scenarioValue(item) === this.form.scenario_type);
        return option ? this.scenarioDescription(option) : '';
    }

    public templateIdForScenario(value: string, mediaType: string = this.form.media_type) {
        const normalizedType = this.normalizeMediaType(mediaType) || 'image';
        const option = this.scenarios.find((item: any) =>
            this.scenarioValue(item) === value &&
            (this.normalizeMediaType(item?.media_type || 'image') || 'image') === normalizedType
        );
        const direct = option?.template_id || option?.id;
        if (direct) return direct;
        const template = this.templates.find((item: any) =>
            item?.scenario_type === value &&
            (this.normalizeMediaType(item?.media_type || 'image') || 'image') === normalizedType &&
            (!item?.status || item.status === 'active')
        );
        return template?.id || template?.template_id || '';
    }

    public scenarioLabel(value: string) {
        const option = this.scenarios.find((item: any) => this.scenarioValue(item) === value);
        return option ? this.scenarioOptionLabel(option) : (value || '시나리오 미지정');
    }

    public jobScenario(job: any) {
        return this.scenarioLabel(job?.scenario_type || job?.scenario || job?.prompt_snapshot?.scenario_type || '');
    }

    public jobIntensity(job: any) {
        const value = Number(job?.intensity || job?.prompt_snapshot?.intensity || 0);
        return value > 0 ? value : '-';
    }

    public artifacts(item: any) {
        const asset = item?.asset || item?.media_asset || {};
        if (Array.isArray(item?.artifacts)) return item.artifacts;
        if (Array.isArray(asset?.artifacts)) return asset.artifacts;
        return [];
    }

    public artifactRole(artifact: any) {
        return String(artifact?.role || artifact?.kind || '').trim().toLowerCase();
    }

    public safeSignedUrl(value: any) {
        const url = String(value || '').trim();
        if (!url.startsWith('/api/ptsd/assets/file?') || url.includes('\\') || /[\r\n]/.test(url)) return '';
        return url;
    }

    public artifactUrl(artifact: any) {
        return this.safeSignedUrl(artifact?.signed_url);
    }

    public masterUrl(item: any) {
        if (item?.preview_failed) return '';
        const asset = item?.asset || item?.media_asset || {};
        return this.safeSignedUrl(item?.signed_url || item?.preview_url || asset?.signed_url || asset?.preview_url);
    }

    public derivative(item: any, roles: string[], mimePrefix: string = '') {
        return this.artifacts(item).find((artifact: any) => {
            const role = this.artifactRole(artifact);
            const mime = String(artifact?.mime_type || '').toLowerCase();
            return roles.includes(role) && (!mimePrefix || mime.startsWith(mimePrefix)) && !!this.artifactUrl(artifact);
        }) || null;
    }

    public visualUrl(item: any) {
        if (item?.preview_failed) return '';
        const mediaType = this.mediaType(item);
        if (mediaType === 'audio') {
            const waveform = this.derivative(item, ['waveform'], 'image/');
            return waveform ? this.artifactUrl(waveform) : '';
        }
        const thumbnail = this.derivative(item, ['thumbnail', 'preview'], 'image/');
        if (thumbnail) return this.artifactUrl(thumbnail);
        return mediaType === 'image' ? this.masterUrl(item) : '';
    }

    public playerUrl(item: any) {
        const mediaType = this.mediaType(item);
        if (mediaType === 'image') return this.visualUrl(item);
        const preview = this.derivative(item, ['preview'], mediaType + '/');
        return preview ? this.artifactUrl(preview) : this.masterUrl(item);
    }

    public posterUrl(item: any) {
        const poster = this.derivative(item, ['thumbnail'], 'image/');
        return poster ? this.artifactUrl(poster) : '';
    }

    public hasPlayablePreview(item: any) {
        return !!(this.mediaType(item) === 'image' ? this.masterUrl(item) : this.playerUrl(item));
    }

    public isQuarantinedAsset(item: any) {
        const asset = this.primaryMetadata(item);
        const safetyStatus = String(asset?.safety_status || item?.safety_status || '').toLowerCase();
        const reviewStatus = String(asset?.review_status || item?.review_status || item?.status || '').toLowerCase();
        return safetyStatus === 'quarantined' || reviewStatus === 'quarantined';
    }

    public previewUrl(item: any) {
        return this.mediaType(item) === 'image' ? this.visualUrl(item) : this.playerUrl(item);
    }

    public primaryMetadata(item: any) {
        return item?.asset || item?.media_asset || item || {};
    }

    public dimensions(item: any) {
        const data = this.primaryMetadata(item);
        if (data?.width && data?.height) return data.width + ' × ' + data.height;
        const candidate = this.artifacts(item).find((artifact: any) => artifact?.width && artifact?.height);
        return candidate ? candidate.width + ' × ' + candidate.height : '-';
    }

    public duration(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => Number(value?.duration_ms) > 0);
        const milliseconds = Number(data?.duration_ms || artifact?.duration_ms || 0);
        if (!milliseconds) return '-';
        const seconds = Math.round(milliseconds / 100) / 10;
        return seconds.toFixed(seconds >= 10 ? 0 : 1) + '초';
    }

    public codec(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => value?.codec || value?.container_format);
        const codec = data?.codec || artifact?.codec || '-';
        const container = data?.container_format || artifact?.container_format || '';
        return container && container !== codec ? codec + ' · ' + container : codec;
    }

    public audioSpec(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => value?.sample_rate_hz || value?.channels || value?.bit_depth);
        const sampleRate = Number(data?.sample_rate_hz || artifact?.sample_rate_hz || 0);
        const channels = Number(data?.channels || artifact?.channels || 0);
        const bits = Number(data?.bit_depth || artifact?.bit_depth || 0);
        const values = [];
        if (sampleRate) values.push((sampleRate / 1000).toFixed(sampleRate % 1000 ? 1 : 0) + 'kHz');
        if (channels) values.push(channels + 'ch');
        if (bits) values.push(bits + 'bit');
        return values.join(' · ') || '-';
    }

    public frameRate(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => value?.frame_rate_milli || value?.fps);
        const milli = Number(data?.frame_rate_milli || artifact?.frame_rate_milli || 0);
        const fps = Number(data?.fps || artifact?.fps || (milli ? milli / 1000 : 0));
        return fps ? (Math.round(fps * 10) / 10) + 'fps' : '-';
    }

    public bitrate(item: any) {
        const data = this.primaryMetadata(item);
        const artifact = this.artifacts(item).find((value: any) => Number(value?.bitrate_bps) > 0);
        const bitsPerSecond = Number(data?.bitrate_bps || artifact?.bitrate_bps || 0);
        return bitsPerSecond ? Math.round(bitsPerSecond / 1000) + 'kbps' : '-';
    }

    public technicalSummary(item: any) {
        const mediaType = this.mediaType(item);
        if (mediaType === 'image') return this.dimensions(item);
        const values = mediaType === 'audio'
            ? [this.duration(item), this.audioSpec(item), this.codec(item), this.bitrate(item)]
            : [this.duration(item), this.dimensions(item), this.frameRate(item), this.codec(item), this.bitrate(item)];
        return values.filter((value: string) => value !== '-').join(' · ') || '-';
    }

    public metricPayload(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
        return value?.last_24h && typeof value.last_24h === 'object' ? value.last_24h : value;
    }

    public todayLabel() {
        const date = new Date();
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            weekday: 'short'
        }).format(date);
    }

    public closeIntensityHelpDetails(event: Event) {
        const target = event.currentTarget as HTMLElement | null;
        const details = target?.tagName === 'DETAILS'
            ? target as HTMLDetailsElement
            : target?.closest('details') as HTMLDetailsElement | null;
        if (!details) return;
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
    }

    public onIntensityInput(event: Event) {
        const input = event.target as HTMLInputElement | null;
        if (!input) return;
        const intensity = this.normalizeIntensityValue(input.value);
        const labels: any = {
            1: '1 (배경 맥락 중심)',
            2: '2 (승인 단서 일부 반영)',
            3: '3 (핵심 단서 반영)',
            4: '4 (구체 단서 대부분 반영)',
            5: '5 (승인 진술 최대 충실 반영)'
        };

        input.value = String(intensity);
        input.setAttribute('aria-valuenow', String(intensity));
        this.form.intensity = intensity;
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();

        const section = input.closest('.content-intensity-section, .content-rail-section');
        const valueOutput = section?.querySelector<HTMLOutputElement>(
            '#content-intensity-value'
        );
        const description = section?.querySelector<HTMLElement>(
            '#content-intensity-description'
        );
        if (valueOutput) valueOutput.value = String(intensity);
        if (description) {
            description.textContent = '현재 설정: ' + labels[intensity];
        }
    }

    public setIntensity(value: number) {
        this.form.intensity = this.normalizeIntensityValue(value);
        this.clearLatestImageCostBatch();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.changeDetector.detectChanges();
    }

    public intensityDescription() {
        const labels: any = {
            1: '1 (배경 맥락 중심)',
            2: '2 (승인 단서 일부 반영)',
            3: '3 (핵심 단서 반영)',
            4: '4 (구체 단서 대부분 반영)',
            5: '5 (승인 진술 최대 충실 반영)'
        };
        return labels[Number(this.form.intensity)] || '-';
    }

    public contentSummaryRows() {
        const assets = Array.isArray(this.assets) ? this.assets : [];
        const imageAssets = assets.filter((asset: any) => this.mediaType(asset) === 'image');
        const videoAssets = assets.filter((asset: any) => this.mediaType(asset) === 'video');
        return [
            {
                label: '이미지 후보',
                value: imageAssets.length + '개',
                icon: 'fa-regular fa-images text-blue-600'
            },
            {
                label: '오디오 자산',
                value: assets.filter((asset: any) => this.mediaType(asset) === 'audio').length + '개',
                icon: 'fa-solid fa-wave-square text-emerald-600'
            },
            {
                label: '영상 클립',
                value: videoAssets.length + '개',
                icon: 'fa-solid fa-film text-violet-600'
            }
        ];
    }

    public allReviewAssets(mediaType: string = this.form.media_type) {
        const targetType = this.normalizeMediaType(mediaType) || 'image';
        const completedReplacementTargets = new Set(
            (Array.isArray(this.jobs) ? this.jobs : [])
                .filter((job: any) =>
                    !!String(job?.replaces_job_id || '')
                    && !!String(job?.asset_revision_id || job?.asset?.id || '')
                    && ['review_pending', 'approved'].includes(
                        String(job?.status || '').toLowerCase()
                    )
                )
                .map((job: any) => String(job.replaces_job_id))
        );
        return (Array.isArray(this.assets) ? [...this.assets] : [])
            .filter((asset: any) =>
                this.mediaType(asset) === targetType
                && !completedReplacementTargets.has(this.jobId(asset))
            )
            .sort((left: any, right: any) => {
                const leftBatch = String(left?.candidate_batch_id || '');
                const rightBatch = String(right?.candidate_batch_id || '');
                if (leftBatch && rightBatch && leftBatch === rightBatch) {
                    return Number(left?.candidate_index || 0) - Number(right?.candidate_index || 0);
                }
                const leftTime = new Date(left?.created_at || left?.created || 0).getTime();
                const rightTime = new Date(right?.created_at || right?.created || 0).getTime();
                return rightTime - leftTime;
            });
    }

    public reviewAssets() {
        const targetType = this.normalizeMediaType(this.form.media_type) || 'image';
        const rows = this.allReviewAssets(targetType);
        if (targetType !== 'video') return rows;
        const modelKey = this.effectiveVideoResultModelKey();
        const sourceRows = this.videoComparisonAssets();
        return modelKey === 'all'
            ? sourceRows
            : sourceRows.filter((asset: any) => this.videoAssetModelKey(asset) === modelKey);
    }

    public videoSourceRevisionId(asset: any) {
        const data = this.primaryMetadata(asset);
        const provenance = data?.provenance || asset?.provenance || {};
        return String(
            asset?.source_asset_revision_id
            || asset?.source_revision_id
            || data?.source_asset_revision_id
            || provenance?.source_asset_revision_id
            || ''
        );
    }

    public videoComparisonAssets() {
        return this.allReviewAssets('video');
    }

    public videoComparisonSourceCount() {
        const sourceIds = this.videoComparisonAssets()
            .map((asset: any) => this.videoSourceRevisionId(asset))
            .filter((value: string) => !!value);
        return new Set(sourceIds).size;
    }

    public videoAssetModelKey(asset: any) {
        const data = this.primaryMetadata(asset);
        const provenance = data?.provenance || asset?.provenance || {};
        const provider = String(
            asset?.provider_name
            || asset?.provider
            || data?.provider_name
            || data?.provider
            || provenance?.provider_name
            || provenance?.provider
            || ''
        ).toLowerCase();
        const model = String(
            asset?.model_name
            || asset?.model
            || data?.model_name
            || provenance?.model_name
            || data?.engine_name
            || ''
        ).toLowerCase();
        if (provider.includes('kling') || model.includes('kling')) return 'kling-video-3';
        if (provider.includes('evolink') || model.includes('seedance')) return 'evolink-seedance-2-5';
        if (provider.includes('comfy') || model.includes('wan2.2') || model.includes('wan-2')) return 'wan-2-2';
        if (provider === 'mock' || model.includes('fixture')) return 'mock';
        return 'other';
    }

    public videoAssetModelLabel(asset: any) {
        const key = this.videoAssetModelKey(asset);
        const option = this.generationModelOptions.video.find((item: any) => item.value === key);
        if (option) return option.label;
        if (key === 'mock') return '테스트용 mock 영상';
        const data = this.primaryMetadata(asset);
        const provenance = data?.provenance || asset?.provenance || {};
        return String(asset?.model_name || data?.model_name || provenance?.model_name || '기타 모델');
    }

    public videoAssetModelClass(asset: any) {
        const classes: any = {
            'kling-video-3': 'border-cyan-200 bg-cyan-50 text-cyan-800',
            'evolink-seedance-2-5': 'border-rose-200 bg-rose-50 text-rose-800',
            'wan-2-2': 'border-violet-200 bg-violet-50 text-violet-800',
            mock: 'border-slate-200 bg-slate-100 text-slate-600'
        };
        return classes[this.videoAssetModelKey(asset)] || 'border-slate-200 bg-white text-slate-700';
    }

    public videoGenerationElapsedLabel(asset: any) {
        const started = new Date(asset?.started_at || 0).getTime();
        const completed = new Date(
            asset?.completed_at || asset?.updated_at || asset?.updated || 0
        ).getTime();
        if (
            !Number.isFinite(started)
            || !Number.isFinite(completed)
            || started <= 0
            || completed < started
        ) return '기록 없음';

        const seconds = Math.max(0, Math.round((completed - started) / 1000));
        if (seconds < 1) return '1초 미만';
        if (seconds < 60) return `${seconds}초`;
        const minutes = Math.floor(seconds / 60);
        const secondRemainder = seconds % 60;
        if (minutes < 60) {
            return secondRemainder > 0
                ? `${minutes}분 ${secondRemainder}초`
                : `${minutes}분`;
        }
        const hours = Math.floor(minutes / 60);
        const minuteRemainder = minutes % 60;
        return minuteRemainder > 0
            ? `${hours}시간 ${minuteRemainder}분`
            : `${hours}시간`;
    }

    public videoResultModelOptions() {
        const rows = this.videoComparisonAssets();
        const options = [
            { value: 'all', label: '전체' },
            { value: 'kling-video-3', label: 'Kling' },
            { value: 'evolink-seedance-2-5', label: 'Seedance' },
            { value: 'wan-2-2', label: 'Wan 2.2' }
        ];
        return options.map((option: any) => ({
            ...option,
            count: option.value === 'all'
                ? rows.length
                : rows.filter((asset: any) => this.videoAssetModelKey(asset) === option.value).length
        }));
    }

    public effectiveVideoResultModelKey() {
        const selected = String(this.selectedVideoResultModelKey || 'all');
        if (selected === 'all') return selected;
        const option = this.videoResultModelOptions().find((item: any) => item.value === selected);
        return option && option.count > 0 ? selected : 'all';
    }

    public selectVideoResultModel(modelKey: string) {
        const option = this.videoResultModelOptions().find((item: any) => item.value === modelKey);
        if (!option || option.count < 1) return;
        this.selectedVideoResultModelKey = option.value;
        this.changeDetector.detectChanges();
    }

    public setContentTab(mediaType: string) {
        const next = this.normalizeMediaType(mediaType);
        if (!next || this.form.media_type === next) return;
        this.form.media_type = next;
        this.filters.status = '';
        this.syncScenarioForSelectedPatient();
        this.form.idempotency_key = this.newIdempotencyKey();
        this.selectedReviewAssetId = '';
        this.changeDetector.detectChanges();
    }

    public selectReviewAsset(asset: any) {
        this.selectedReviewAssetId = this.assetId(asset);
        this.changeDetector.detectChanges();
    }

    public currentReviewAsset() {
        const rows = this.reviewAssets();
        if (rows.length === 0) return null;
        const selectedId = String(this.selectedReviewAssetId || '');
        const selected = rows.find((asset: any) => this.assetId(asset) === selectedId);
        if (selected) return selected;

        const source = this.form.media_type === 'image'
            ? this.selectedVideoSource
            : (this.form.media_type === 'audio' ? this.selectedAudioSource : null);
        const sourceId = this.assetId(source);
        return rows.find((asset: any) => this.assetId(asset) === sourceId) || rows[0];
    }

    public isReviewAssetSelected(asset: any) {
        return this.assetId(this.currentReviewAsset()) === this.assetId(asset);
    }

    public isConfirmedReviewAsset(asset: any) {
        const type = this.mediaType(asset);
        if (type === 'image') return this.isSelectedVideoSource(asset);
        if (type === 'audio') return this.isSelectedAudioSource(asset);
        return !!this.confirmedReviewAssetId
            && this.confirmedReviewAssetId === this.assetId(asset);
    }

    public chooseReviewAsset(asset: any) {
        if (!asset) return;
        this.selectedReviewAssetId = this.assetId(asset);
        this.confirmedReviewAssetId = this.assetId(asset);
        const type = this.mediaType(asset);
        if (type === 'image' && !this.isSelectedVideoSource(asset)) {
            this.selectVideoSource(asset);
            return;
        }
        if (type === 'audio' && !this.isSelectedAudioSource(asset)) {
            this.selectAudioSource(asset);
            return;
        }
        this.changeDetector.detectChanges();
    }

    public reviewSelectionLabel(asset: any) {
        return this.isConfirmedReviewAsset(asset) ? '선택됨' : '후보 선택';
    }

    public selectedAssetGenerationModelLabel(item: any) {
        if (!item) return '-';
        if (this.mediaType(item) === 'video') return this.videoAssetModelLabel(item);
        const data = this.primaryMetadata(item);
        const usage = this.generationUsage(item);
        const provider = String(
            usage?.provider_name
            || data?.provider_name
            || item?.provider_name
            || ''
        ).toLowerCase();
        const model = String(
            usage?.model_name
            || data?.model_name
            || item?.model_name
            || ''
        );
        if (provider.includes('openai') || model.toLowerCase().includes('gpt-image')) {
            return 'OpenAI · GPT Image 2';
        }
        if (provider.includes('kling') || model.toLowerCase().includes('kling-v2-1') || model.toLowerCase().includes('kling-v3')) {
            return 'Kling AI · Image 2.1';
        }
        if (provider.includes('evolink') || model.toLowerCase().includes('seedream')) {
            return 'EvoLink · Seedream 5.0 Lite';
        }
        if (model) return model;
        if (this.mediaType(item) === 'audio') return '선택 프롬프트 세트 기본 모델';
        const key = String(this.selectedGenerationModelKeys?.image || '');
        const option = (this.generationModelOptions.image || []).find(
            (candidate: any) => candidate.value === key
        );
        return option?.label || '-';
    }

    public selectedAssetStatusLabel(item: any) {
        if (!item) return '-';
        const data = this.primaryMetadata(item);
        return this.statusLabel(
            data?.review_status || item?.review_status || item?.status || ''
        );
    }

    public selectedAssetCostLabel(item: any) {
        return this.generationUsageAvailable(item)
            ? this.generationCostLabel(item)
            : '-';
    }

    public currentGenerationCostLabel() {
        const item = this.visibleGenerationCostItem();
        return item ? this.generationCostLabel(item) : '요청 후 계산';
    }

    public isSelectedSource(asset: any) {
        return this.isSelectedVideoSource(asset) || this.isSelectedAudioSource(asset);
    }

    public intensityBatchJobs() {
        const batchId = String(this.latestIntensityBatchId || '');
        if (!batchId) return [];
        return (Array.isArray(this.jobs) ? this.jobs : [])
            .filter((job: any) => String(job?.intensity_batch_id || '') === batchId)
            .sort((left: any, right: any) => {
                const intensityDiff = this.jobIntensity(left) - this.jobIntensity(right);
                if (intensityDiff) return intensityDiff;
                return Number(left?.candidate_index || 0) - Number(right?.candidate_index || 0);
            });
    }

    public intensityBatchProgress() {
        const jobs = this.intensityBatchJobs();
        if (jobs.length === 0) return 0;
        return Math.round(
            jobs.reduce((total: number, job: any) => total + this.jobProgress(job), 0)
            / jobs.length
        );
    }

    public intensityBatchRows() {
        const jobs = this.intensityBatchJobs();
        return this.intensityOptions.map((intensity: number) => {
            const rows = jobs.filter((job: any) => this.jobIntensity(job) === intensity);
            const completed = rows.filter((job: any) => [
                'review_pending', 'approved', 'rejected', 'quarantined'
            ].includes(String(job?.status || '').toLowerCase())).length;
            const failed = rows.filter((job: any) =>
                String(job?.status || '').toLowerCase() === 'failed'
            ).length;
            const cancelled = rows.filter((job: any) =>
                String(job?.status || '').toLowerCase() === 'cancelled'
            ).length;
            const progress = rows.length
                ? Math.round(rows.reduce(
                    (total: number, job: any) => total + this.jobProgress(job),
                    0
                ) / rows.length)
                : 0;
            return {
                intensity,
                total: rows.length,
                completed,
                failed,
                cancelled,
                progress
            };
        });
    }

    public canCancelIntensityBatch() {
        return this.intensityBatchJobs().some((job: any) => [
            'queued', 'running', 'postprocessing'
        ].includes(String(job?.status || '').toLowerCase()));
    }

    public canRetryIntensityBatch() {
        const retryable = this.intensityBatchJobs().filter((job: any) => [
            'failed', 'cancelled'
        ].includes(String(job?.status || '').toLowerCase()));
        return retryable.length > 0 && retryable.every(
            (job: any) => this.jobGenerationModelAvailable(job)
        );
    }

    public async cancelIntensityBatch() {
        if (!this.can('content.write') || !this.canCancelIntensityBatch() || this.intensityBatchAction) return;
        const confirmed = await this.service.modal.show({
            title: '강도별 이미지 생성 취소',
            message: '아직 완료되지 않은 강도 1~5 이미지 생성 작업을 모두 취소합니다.',
            action: '일괄 취소',
            cancel: '계속 진행',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        this.intensityBatchAction = true;
        try {
            const { code, data } = await wiz.call('cancel_intensity_batch', {
                intensity_batch_id: this.latestIntensityBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 생성을 취소하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.intensityBatchAction = false;
            await this.service.render();
        }
    }

    public async retryIntensityBatch() {
        if (!this.can('content.write') || !this.canRetryIntensityBatch() || this.intensityBatchAction) return;
        this.intensityBatchAction = true;
        try {
            const { code, data } = await wiz.call('retry_intensity_batch', {
                intensity_batch_id: this.latestIntensityBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 생성을 다시 시도하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.intensityBatchAction = false;
            await this.service.render();
        }
    }

    public videoBatchJobs() {
        const batchId = String(this.latestVideoBatchId || '');
        if (!batchId) return [];
        return (Array.isArray(this.jobs) ? this.jobs : [])
            .filter((job: any) => String(job?.video_batch_id || '') === batchId)
            .sort((left: any, right: any) => this.jobIntensity(left) - this.jobIntensity(right));
    }

    public videoBatchProgress() {
        const jobs = this.videoBatchJobs();
        if (jobs.length === 0) return 0;
        return Math.round(jobs.reduce(
            (total: number, job: any) => total + this.jobProgress(job),
            0
        ) / jobs.length);
    }

    public canCancelVideoBatch() {
        return this.videoBatchJobs().some((job: any) => [
            'queued', 'running', 'postprocessing'
        ].includes(String(job?.status || '').toLowerCase()));
    }

    public canRetryVideoBatch() {
        return this.videoBatchJobs().some((job: any) => [
            'failed', 'cancelled'
        ].includes(String(job?.status || '').toLowerCase()));
    }

    public async cancelVideoBatch() {
        if (!this.can('content.write') || !this.canCancelVideoBatch() || this.videoBatchAction) return;
        const confirmed = await this.service.modal.show({
            title: '강도별 영상 생성 취소',
            message: '아직 완료되지 않은 강도별 영상 작업을 모두 취소합니다.',
            action: '일괄 취소',
            cancel: '계속 진행',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        this.videoBatchAction = true;
        try {
            const { code, data } = await wiz.call('cancel_video_batch', {
                video_batch_id: this.latestVideoBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 영상 생성을 취소하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.videoBatchAction = false;
            await this.service.render();
        }
    }

    public async retryVideoBatch() {
        if (!this.can('content.write') || !this.canRetryVideoBatch() || this.videoBatchAction) return;
        this.videoBatchAction = true;
        try {
            const { code, data } = await wiz.call('retry_video_batch', {
                video_batch_id: this.latestVideoBatchId,
                csrf_token: this.csrfToken()
            });
            if (code !== 200) {
                await this.service.modal.error(data?.message || '강도별 영상 생성을 다시 시도하지 못했습니다.');
                return;
            }
            this.extractList(data, ['jobs']).forEach((job: any) => this.upsertJob(job));
            await this.search(false);
        } finally {
            this.videoBatchAction = false;
            await this.service.render();
        }
    }

    public activeJob() {
        const targetType = this.normalizeMediaType(this.form.media_type) || 'image';
        return (Array.isArray(this.jobs) ? this.jobs : []).find((job: any) =>
            this.mediaType(job) === targetType
            &&
            ['queued', 'running', 'postprocessing'].includes(
                String(job?.status || '').toLowerCase()
            )
        ) || null;
    }

    public progressJob() {
        if (!this.progressJobId) return null;
        return (Array.isArray(this.jobs) ? this.jobs : []).find(
            (job: any) => this.jobId(job) === this.progressJobId
        ) || null;
    }

    public activeJobSummary() {
        const job = this.activeJob();
        if (!job) {
            if (!this.form.patient_id) return '환자를 선택하면 작업 상태가 표시됩니다.';
            return '현재 진행 중인 생성 작업이 없습니다.';
        }
        const label = this.candidateLabel(job) || this.modalityLabel(job);
        return label + ' · 강도 ' + this.jobIntensity(job) + ' · ' + this.statusLabel(job.status);
    }

    public progressStatusDescription(job: any) {
        const status = String(job?.status || '').toLowerCase();
        if (job?.cancel_requested && ['queued', 'running', 'postprocessing'].includes(status)) {
            return '취소 요청을 전달했습니다. worker가 안전하게 작업을 중단한 뒤 상태가 갱신됩니다.';
        }
        const descriptions: any = {
            queued: '요청이 등록되어 worker 대기열에서 실행 순서를 기다리고 있습니다.',
            running: 'worker가 원본 자산을 확인하고 선택한 AI 모델로 생성을 진행하고 있습니다.',
            postprocessing: '생성 결과의 형식과 무결성을 확인한 뒤 안전한 저장소에 보관하고 있습니다.',
            review_pending: '생성이 완료되어 콘텐츠 자산으로 저장되었습니다.',
            approved: '생성이 완료되고 안전 검토를 통과했습니다.',
            rejected: '생성 결과가 검토에서 반려되었습니다.',
            quarantined: '외부 모델 생성은 완료됐으며 안전 검토 전까지 격리되어 있습니다.',
            cancelled: '사용자 요청으로 생성 작업이 취소되었습니다.'
        };
        if (status === 'failed') return this.jobErrorMessage(job);
        return descriptions[status] || '서버에서 최신 작업 상태를 확인하고 있습니다.';
    }

    public progressStageRows(job: any) {
        const status = String(job?.status || '').toLowerCase();
        const success = ['review_pending', 'approved', 'rejected', 'quarantined'].includes(status);
        const stageIndex: any = { queued: 1, running: 2, postprocessing: 3 };
        const current = stageIndex[status];
        const errorIndex = job?.started_at ? 2 : 1;
        const stages = [
            { label: '요청 등록', description: '생성 요청과 설정을 안전하게 등록했습니다.' },
            { label: '대기열 배정', description: 'worker가 실행할 작업 순서를 확인합니다.' },
            { label: 'AI 모델 생성', description: '선택한 모델이 원본 자산으로 결과를 생성합니다.' },
            { label: '결과 검증·저장', description: '결과 형식과 무결성을 검사하고 저장합니다.' },
            { label: '생성 완료', description: '콘텐츠 자산으로 등록하고 검토 상태를 반영합니다.' }
        ];
        return stages.map((stage: any, index: number) => {
            let state = 'pending';
            if (success) state = 'complete';
            else if (status === 'failed' || status === 'cancelled') {
                if (index < errorIndex) state = 'complete';
                else if (index === errorIndex) state = 'error';
            } else if (Number.isInteger(current)) {
                if (index < current) state = 'complete';
                else if (index === current) state = 'current';
            }
            return { ...stage, state };
        });
    }

    public progressModelLabel(job: any) {
        const model = String(job?.model_name || job?.model || '').toLowerCase();
        const provider = String(job?.provider_name || job?.provider || '').toLowerCase();
        if (model.includes('kling') || provider.includes('kling')) return 'Kling AI · Video 3.0';
        if (model.includes('seedance') || provider.includes('evolink')) return 'EvoLink · Seedance 2.5';
        if (model.includes('wan') || provider.includes('comfy')) return 'ComfyUI · Wan 2.2';
        if (model.includes('gpt-image') || provider.includes('openai')) return 'OpenAI · GPT Image 2';
        return String(job?.model_name || job?.model || job?.provider_name || job?.provider || '-');
    }

    public progressDetailRows(job: any) {
        const rows: any[] = [
            { label: '생성 모델', value: this.progressModelLabel(job) },
            { label: '현재 상태', value: this.statusLabel(job?.status) }
        ];
        if (this.mediaType(job) === 'video') {
            rows.push({ label: '영상 길이', value: `${this.videoDurationForJob(job)}초` });
        }
        rows.push(
            { label: '요청 시각', value: this.formatDate(job?.created_at || job?.created) },
            { label: '시작 시각', value: this.formatDate(job?.started_at) },
            { label: '경과 시간', value: this.progressElapsedLabel(job) },
            { label: '시도 횟수', value: `${Math.max(0, Number(job?.attempt_count || 0))} / ${Math.max(1, Number(job?.max_attempts || 3))}회` }
        );
        return rows;
    }

    public progressElapsedLabel(job: any) {
        const started = new Date(job?.started_at || job?.created_at || job?.created || 0).getTime();
        if (!Number.isFinite(started) || started <= 0) return '-';
        const status = String(job?.status || '').toLowerCase();
        const terminal = ['review_pending', 'approved', 'rejected', 'failed', 'cancelled', 'quarantined'].includes(status);
        const finished = terminal
            ? new Date(job?.completed_at || job?.updated_at || job?.updated || Date.now()).getTime()
            : Date.now();
        const seconds = Math.max(0, Math.floor((finished - started) / 1000));
        if (seconds < 60) return `${seconds}초`;
        const minutes = Math.floor(seconds / 60);
        const remainder = seconds % 60;
        if (minutes < 60) return remainder > 0 ? `${minutes}분 ${remainder}초` : `${minutes}분`;
        const hours = Math.floor(minutes / 60);
        const minuteRemainder = minutes % 60;
        return minuteRemainder > 0 ? `${hours}시간 ${minuteRemainder}분` : `${hours}시간`;
    }

    public progressEstimateLabel(job: any) {
        const status = String(job?.status || '').toLowerCase();
        if (['review_pending', 'approved', 'rejected', 'failed', 'cancelled', 'quarantined'].includes(status)) {
            return '작업 종료';
        }
        if (this.mediaType(job) === 'video') return this.videoEstimateLabel(job);
        return '3초마다 최신 상태 자동 갱신';
    }

    public videoEstimateLabel(job: any = null) {
        const estimate = this.videoEstimateSeconds(job);
        const prefix = job ? '예상 완료까지' : '예상 소요 시간';
        return `${prefix} 약 ${this.durationRangeLabel(estimate.low, estimate.high)}`;
    }

    public videoEstimateBasisLabel() {
        const distribution = this.videoLatencyDistribution();
        return distribution.count > 0
            ? `최근 완료된 영상 ${distribution.count}건의 실제 처리시간 기준입니다.`
            : '완료 이력이 부족해 영상 길이 기준 범위로 안내합니다.';
    }

    public latestActivityDate() {
        const values = [
            ...(Array.isArray(this.jobs) ? this.jobs : []),
            ...(Array.isArray(this.assets) ? this.assets : [])
        ];
        if (values.length === 0) return '-';
        const latest = [...values].sort((left: any, right: any) => {
            const leftTime = new Date(
                left?.updated_at || left?.created_at || left?.created || 0
            ).getTime();
            const rightTime = new Date(
                right?.updated_at || right?.created_at || right?.created || 0
            ).getTime();
            return rightTime - leftTime;
        })[0];
        return this.formatDate(
            latest?.updated_at || latest?.created_at || latest?.created
        );
    }

    public assetReviewStatusLabel(asset: any) {
        const status = this.assetReviewStatus(asset);
        const labels: any = {
            approved: '승인',
            pending: '생성 완료',
            review_pending: '생성 완료',
            rejected: '반려',
            quarantined: '격리'
        };
        return {
            status: status || 'pending',
            label: labels[status] || '확인 필요'
        };
    }

    public patientOverviewCards() {
        const patient = this.selectedPatientOption();
        const jobs = Array.isArray(this.jobs) ? this.jobs : [];
        const assets = Array.isArray(this.assets) ? this.assets : [];
        const activeStatuses = ['queued', 'running', 'postprocessing'];
        const inProgress = jobs.filter((job: any) =>
            activeStatuses.includes(String(job?.status || '').toLowerCase())
        ).length;
        const restricted = assets.filter((asset: any) =>
            ['rejected', 'quarantined'].includes(this.assetReviewStatus(asset))
            || this.assetSafetyStatus(asset) !== 'passed'
        ).length;
        const readyToUse = assets.filter((asset: any) =>
            ['pending', 'review_pending', 'approved'].includes(
                this.assetReviewStatus(asset)
            )
            && this.assetSafetyStatus(asset) === 'passed'
        ).length;
        const mediaCounts = ['image', 'audio', 'video'].reduce(
            (result: any, mediaType: string) => {
                result[mediaType] = assets.filter(
                    (asset: any) => this.mediaType(asset) === mediaType
                ).length;
                return result;
            },
            {}
        );
        const mediaSummary = [
            mediaCounts.image ? '이미지 ' + this.formatCount(mediaCounts.image) : '',
            mediaCounts.audio ? '오디오 ' + this.formatCount(mediaCounts.audio) : '',
            mediaCounts.video ? '영상 ' + this.formatCount(mediaCounts.video) : ''
        ].filter(Boolean).join(' · ') || '생성 자산 없음';
        const prompt = this.selectedPatientPromptSummary();

        return [
            {
                label: '선택 환자',
                value: this.patientLabel(patient),
                note: '현재 작업 범위',
                tone: 'bg-indigo-500'
            },
            {
                label: '승인 프롬프트',
                value: prompt.value,
                note: prompt.note,
                tone: prompt.tone
            },
            {
                label: '생성 진행',
                value: this.formatCount(inProgress) + '건',
                note: '대기·생성·후처리',
                tone: inProgress > 0 ? 'bg-blue-500' : 'bg-gray-300'
            },
            {
                label: '생성 완료',
                value: this.formatCount(assets.length) + '개',
                note: mediaSummary,
                tone: assets.length > 0 ? 'bg-cyan-500' : 'bg-gray-300'
            },
            {
                label: '사용 제한',
                value: this.formatCount(restricted) + '건',
                note: '안전 미통과·격리',
                tone: restricted > 0 ? 'bg-amber-500' : 'bg-emerald-500'
            },
            {
                label: '사용 가능',
                value: this.formatCount(readyToUse) + '개',
                note: '생성 완료·안전 통과',
                tone: readyToUse > 0 ? 'bg-emerald-500' : 'bg-gray-300'
            }
        ];
    }

    public selectedPatientPromptSummary() {
        if (this.selectedPatientPromptReady()) {
            return {
                value: '승인 완료',
                note: '생성에 사용 가능',
                tone: 'bg-emerald-500'
            };
        }
        const status = this.selectedPatientPromptStatus();
        const values: any = {
            review_required: {
                value: '검토 필요',
                note: '임상의 승인 대기',
                tone: 'bg-amber-500'
            },
            stale: {
                value: '재생성 필요',
                note: '상황 설명 변경됨',
                tone: 'bg-orange-500'
            },
            draft_missing: {
                value: '초안 필요',
                note: 'AI 초안 미생성',
                tone: 'bg-blue-500'
            }
        };
        return values[status] || {
            value: '준비 필요',
            note: '상황 설명 확인',
            tone: 'bg-gray-300'
        };
    }

    private assetReviewStatus(item: any) {
        const data = this.primaryMetadata(item);
        return String(
            data?.review_status || item?.review_status || item?.status || ''
        ).toLowerCase();
    }

    private assetSafetyStatus(item: any) {
        const data = this.primaryMetadata(item);
        return String(
            data?.safety_status || item?.safety_status || ''
        ).toLowerCase();
    }

    public metricCards() {
        const metrics = this.metricPayload(this.metrics);
        const queue = metrics?.queue_depth || metrics?.queue || {};
        const outcomes = metrics?.outcomes || {};
        const dlq = metrics?.dlq || {};
        const latency = metrics?.latency_ms?.total || metrics?.latency?.total || metrics?.latency_ms || {};
        const cost = metrics?.cost_micros || metrics?.cost || {};
        const queueTotal = Number(queue?.total ?? queue?.queued ?? metrics?.queued ?? 0);
        const generated = Number(outcomes?.generated ?? outcomes?.succeeded ?? metrics?.success ?? 0);
        const failed = Number(outcomes?.failed ?? metrics?.failure ?? metrics?.failed ?? 0);
        const p95 = Number(latency?.p95 ?? latency?.p95_ms ?? latency?.max ?? 0);
        const costMicros = Number(cost?.total ?? metrics?.cost_total_micros ?? 0);
        return [
            { label: '처리 대기', value: this.formatCount(queueTotal), note: 'Queue 대기·진행', tone: 'bg-blue-50 text-blue-700' },
            { label: '오류 보류', value: this.formatCount(Number(dlq?.open ?? metrics?.open_dlq ?? 0)), note: 'DLQ 운영 확인 필요', tone: 'bg-orange-50 text-orange-700' },
            { label: '24시간 성공', value: this.formatCount(generated), note: '생성 완료', tone: 'bg-emerald-50 text-emerald-700' },
            { label: '24시간 실패', value: this.formatCount(failed), note: '최종 실패', tone: 'bg-red-50 text-red-700' },
            { label: 'P95 처리시간', value: p95 > 0 ? this.formatLatency(p95) : '-', note: '전체 처리 지연', tone: 'bg-violet-50 text-violet-700' },
            { label: '추정 비용', value: this.formatCost(costMicros), note: '최근 24시간 누적', tone: 'bg-cyan-50 text-cyan-700' }
        ];
    }

    public metricsScopeLabel() {
        const scope = String(this.metrics?.scope || '').toLowerCase();
        if (scope === 'patient') return '선택 환자 범위';
        if (scope === 'assigned') return '담당 환자 범위';
        if (scope === 'review') return '검수 가능 범위';
        return '전체 운영 범위';
    }

    public formatCount(value: number) {
        return Number.isFinite(value) ? new Intl.NumberFormat('ko-KR').format(value) : '0';
    }

    public formatLatency(milliseconds: number) {
        if (!Number.isFinite(milliseconds) || milliseconds <= 0) return '-';
        if (milliseconds >= 1000) return (milliseconds / 1000).toFixed(milliseconds >= 10000 ? 0 : 1) + '초';
        return Math.round(milliseconds) + 'ms';
    }

    public formatCost(micros: number) {
        if (!Number.isFinite(micros) || micros <= 0) return 'US$0.0000';
        return 'US$' + (micros / 1000000).toFixed(4);
    }

    public generationUsage(item: any) {
        const usage = item?.generation_usage || item?.asset?.generation_usage;
        return usage && typeof usage === 'object' ? usage : {};
    }

    public generationUsageAvailable(item: any) {
        return this.generationUsage(item)?.available === true;
    }

    public generationCostLabel(item: any) {
        const usage = this.generationUsage(item);
        const pricingStatus = String(usage?.pricing_status || '').toLowerCase();
        if (pricingStatus === 'no_charge') return '과금 없음';
        if (pricingStatus === 'unpriced' || pricingStatus === 'unpriced_legacy') {
            return '요금 미설정';
        }
        return this.formatCost(Number(usage?.cost_micros || 0));
    }

    public generationUsageDetail(item: any) {
        const usage = this.generationUsage(item);
        const provider = String(usage?.provider_name || '').trim();
        const model = String(usage?.model_name || '').trim();
        const tokens = Number(usage?.total_tokens || 0);
        const requests = Number(usage?.requests || 0);
        const parts = [provider, model].filter((value: string) => !!value);
        if (tokens > 0) parts.push(this.formatCount(tokens) + ' tokens');
        if (requests > 1) parts.push(this.formatCount(requests) + '회 시도');
        return parts.join(' · ') || '사용량 기록 완료';
    }

    public latestGenerationCostJob() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        return this.jobs
            .filter((job: any) => (
                this.mediaType(job) === mediaType
                && this.generationUsageAvailable(job)
            ))
            .slice()
            .sort((left: any, right: any) => {
                const leftTime = Date.parse(
                    left?.completed_at || left?.updated_at || left?.created_at || ''
                ) || 0;
                const rightTime = Date.parse(
                    right?.completed_at || right?.updated_at || right?.created_at || ''
                ) || 0;
                return rightTime - leftTime;
            })[0] || null;
    }

    public visibleGenerationCostItem() {
        const mediaType = this.normalizeMediaType(this.form.media_type);
        if (mediaType !== 'video') return this.latestGenerationCostJob();

        const modelKey = this.effectiveVideoResultModelKey();
        if (modelKey === 'all') return null;
        return this.videoComparisonAssets()
            .filter((asset: any) => (
                this.videoAssetModelKey(asset) === modelKey
                && this.generationUsageAvailable(asset)
            ))
            .slice()
            .sort((left: any, right: any) => {
                const leftTime = Date.parse(
                    left?.completed_at || left?.updated_at || left?.created_at || left?.created || ''
                ) || 0;
                const rightTime = Date.parse(
                    right?.completed_at || right?.updated_at || right?.created_at || right?.created || ''
                ) || 0;
                return rightTime - leftTime;
            })[0] || null;
    }

    public generationCostCardTitle() {
        return this.normalizeMediaType(this.form.media_type) === 'video'
            ? '선택 영상 생성 비용'
            : '이번 생성 예상 비용';
    }

    public statusLabel(status: string) {
        const labels: any = {
            queued: '대기',
            running: '생성 중',
            postprocessing: '후처리',
            review_pending: '생성 완료',
            pending: '생성 완료',
            approved: '승인',
            rejected: '반려',
            failed: '실패',
            cancelled: '취소',
            quarantined: '격리'
        };
        return labels[String(status || '').toLowerCase()] || status || '상태 확인 중';
    }

    public jobErrorMessage(job: any) {
        const messages: any = {
            openai_not_configured: 'OpenAI API 설정을 확인해주세요.',
            openai_auth_failed: 'OpenAI API 인증에 실패했습니다.',
            openai_permission_denied: 'OpenAI 이미지 모델 사용 권한이 없습니다.',
            openai_model_unavailable: '설정된 OpenAI 이미지 모델을 사용할 수 없습니다.',
            openai_request_rejected: 'OpenAI가 이미지 생성 요청을 거부했습니다.',
            openai_quota_exhausted: 'OpenAI 사용 한도 또는 크레딧을 확인해주세요.',
            openai_rate_limited: 'OpenAI 요청이 많습니다. 잠시 후 재시도해주세요.',
            openai_unavailable: 'OpenAI 이미지 서비스에 일시적으로 연결할 수 없습니다.',
            openai_generation_failed: 'OpenAI 이미지 생성 중 일시적 오류가 발생했습니다.',
            kling_image_not_configured: 'Kling 이미지 API 설정을 확인해주세요.',
            kling_image_auth_failed: 'Kling 이미지 API 인증에 실패했습니다.',
            kling_image_permission_denied: 'Kling Image 2.1 사용 권한이 없습니다.',
            kling_image_quota_exhausted: 'Kling 이미지 사용 한도 또는 크레딧을 확인해주세요.',
            kling_image_rate_limited: 'Kling 이미지 요청이 많습니다. 잠시 후 재시도해주세요.',
            kling_image_request_rejected: 'Kling이 이미지 생성 요청을 거부했습니다.',
            kling_image_unavailable: 'Kling 이미지 서비스에 일시적으로 연결할 수 없습니다.',
            kling_image_timed_out: 'Kling 이미지 생성 대기 시간이 초과되었습니다.',
            kling_image_generation_failed: 'Kling 이미지 생성에 실패했습니다.',
            kling_image_output_invalid: 'Kling 이미지 결과를 검증하지 못했습니다.',
            evolink_image_not_configured: 'EvoLink 이미지 API 설정을 확인해주세요.',
            evolink_image_auth_failed: 'EvoLink 이미지 API 인증에 실패했습니다.',
            evolink_image_permission_denied: 'Seedream 5.0 Lite 사용 권한이 없습니다.',
            evolink_image_quota_exhausted: 'EvoLink 이미지 사용 한도 또는 크레딧을 확인해주세요.',
            evolink_image_rate_limited: 'EvoLink 이미지 요청이 많습니다. 잠시 후 재시도해주세요.',
            evolink_image_request_rejected: 'EvoLink가 이미지 생성 요청을 거부했습니다.',
            evolink_image_unavailable: 'EvoLink 이미지 서비스에 일시적으로 연결할 수 없습니다.',
            evolink_image_timed_out: 'Seedream 이미지 생성 대기 시간이 초과되었습니다.',
            evolink_image_generation_failed: 'Seedream 이미지 생성에 실패했습니다.',
            evolink_image_output_invalid: 'Seedream 이미지 결과를 검증하지 못했습니다.',
            comfyui_unavailable: 'Wan 2.2 영상 서버에 연결할 수 없습니다. GPU 연결 상태를 확인해주세요.',
            generation_runtime_error: '이미지 생성 중 일시적 오류가 발생했습니다. 재시도해주세요.',
            invalid_generation_result: '생성 결과를 검증하지 못했습니다.'
        };
        const code = String(job?.error_code || job?.last_error_code || '').toLowerCase();
        if (messages[code]) return messages[code];
        const raw = String(job?.error_message || job?.last_error_message || '').trim();
        if (raw && raw !== 'media generation failed' && raw !== 'media generation validation failed') return raw;
        return '이미지 생성에 실패했습니다. 재시도해주세요.';
    }

    public statusClass(status: string) {
        switch (String(status || '').toLowerCase()) {
            case 'approved':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'running':
            case 'postprocessing':
                return 'border-indigo-200 bg-indigo-50 text-indigo-700';
            case 'review_pending':
            case 'pending':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'rejected':
            case 'failed':
                return 'border-red-200 bg-red-50 text-red-700';
            case 'quarantined':
                return 'border-orange-200 bg-orange-50 text-orange-700';
            case 'cancelled':
                return 'border-gray-200 bg-gray-50 text-gray-600';
            default:
                return 'border-blue-200 bg-blue-50 text-blue-700';
        }
    }

    public jobProgress(job: any) {
        const status = String(job?.status || '').toLowerCase();
        if (['review_pending', 'approved', 'rejected', 'quarantined'].includes(status)) {
            return 100;
        }
        const explicit = Number(job?.progress_percent ?? job?.progress);
        if (Number.isFinite(explicit)) return Math.max(0, Math.min(100, explicit));
        const values: any = {
            queued: 5,
            running: 45,
            postprocessing: 80,
            review_pending: 100,
            approved: 100,
            rejected: 100,
            failed: 100,
            cancelled: 100,
            quarantined: 100
        };
        return values[String(job?.status || '').toLowerCase()] ?? 0;
    }

    public canCancel(job: any) {
        if (job?.cancel_requested) return false;
        return ['queued', 'running', 'postprocessing'].includes(String(job?.status || '').toLowerCase());
    }

    public canDeleteJob(item: any) {
        const data = this.primaryMetadata(item);
        const status = String(
            item?.status || data?.review_status || item?.review_status || ''
        ).toLowerCase();
        return [
            'review_pending',
            'pending',
            'approved',
            'rejected',
            'failed',
            'cancelled',
            'quarantined'
        ].includes(status);
    }

    public canRetry(job: any) {
        return ['failed', 'cancelled'].includes(String(job?.status || '').toLowerCase())
            && this.jobGenerationModelAvailable(job);
    }

    public pageCount() {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }

    public async changePage(nextPage: number) {
        const target = Math.max(1, Math.min(this.pageCount(), nextPage));
        if (target === this.page || this.searching) return;
        this.page = target;
        await this.search(true, false);
    }

    public formatDate(value: any) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        return new Intl.DateTimeFormat('ko-KR', {
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }

    private normalizeCandidateCount(value: any) {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return 3;
        return Math.max(1, Math.min(5, Math.round(numeric)));
    }

    private normalizeIntensityValue(value: any) {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return 1;
        return Math.max(1, Math.min(5, Math.round(numeric)));
    }

    private csrfToken() {
        return this.csrfTokenValue || this.service.auth?.session?.csrf_token || '';
    }

    private previewRefreshKey(item: any, signedUrl: string = '') {
        const fallbackId = this.assetId(item) || this.jobId(item);
        const url = this.safeSignedUrl(signedUrl);
        if (!url) return fallbackId ? fallbackId + ':master' : '';
        const query = url.slice(url.indexOf('?') + 1);
        const params = new URLSearchParams(query);
        const revisionId = params.get('id') || fallbackId;
        const artifactId = params.get('artifact') || 'master';
        return revisionId ? revisionId + ':' + artifactId : '';
    }

    private newIdempotencyKey() {
        return 'ui-' + Date.now() + '-' + this.service.random(32);
    }

    private extractList(payload: any, keys: string[]) {
        if (Array.isArray(payload)) return payload;
        for (const key of keys) {
            const value = payload?.[key];
            if (Array.isArray(value)) return value;
            if (Array.isArray(value?.items)) return value.items;
        }
        return [];
    }

    private hasListKey(payload: any, keys: string[]) {
        if (!payload || Array.isArray(payload)) return false;
        return keys.some((key: string) => Object.prototype.hasOwnProperty.call(payload, key));
    }

    private scenarioOptionsFromTemplates() {
        const seen: { [key: string]: boolean } = {};
        return this.templates
            .filter((template: any) => !template?.status || template.status === 'active')
            .filter((template: any) => {
                const value = String(template?.scenario_type || '');
                const mediaType = this.normalizeMediaType(template?.media_type || 'image') || 'image';
                const identity = mediaType + ':' + value;
                if (!value || seen[identity]) return false;
                seen[identity] = true;
                return true;
            })
            .map((template: any) => ({
                value: template.scenario_type,
                label: template.name || template.key || template.scenario_type,
                description: template.description || ('Prompt 템플릿 v' + (template.version || '-')),
                template_id: template.id || template.template_id,
                media_type: this.normalizeMediaType(template?.media_type || 'image') || 'image',
                version: template.version,
                positive_prompt_preview: template.positive_prompt_preview || '',
                negative_prompt_preview: template.negative_prompt_preview || ''
            }));
    }

    private applyDefaults() {
        if (!this.form.idempotency_key) this.form.idempotency_key = this.newIdempotencyKey();
        if (!this.videoIdempotencyKey) this.videoIdempotencyKey = this.newIdempotencyKey();
        const patientIds = this.patients.map((patient: any) =>
            String(patient?.id || patient?.patient_id || '')
        );
        if (this.requestedPatientParameterPresent) {
            this.form.patient_id = this.requestedPatientId
                && patientIds.includes(this.requestedPatientId)
                ? this.requestedPatientId
                : '';
        } else if (!patientIds.includes(String(this.form.patient_id || ''))) {
            this.form.patient_id = '';
        }
        this.syncScenarioForSelectedPatient();
    }

    private syncScenarioForSelectedPatient() {
        const available = this.availableScenarios();
        const selectedPatient = this.selectedPatientOption();
        if (selectedPatient) {
            const sourceScenario = this.form.media_type === 'video'
                ? String(
                    this.selectedVideoSource?.scenario_type
                    || this.selectedVideoSource?.scenario
                    || ''
                ).trim()
                : '';
            if (sourceScenario && available.some(
                (item: any) => this.scenarioValue(item) === sourceScenario
            )) {
                this.form.scenario_type = sourceScenario;
                this.promptSelectionMode = 'source';
                this.promptMismatchAcknowledged = this.promptSelectionMismatch(
                    sourceScenario
                );
                return;
            }
            const configuredScenario = String(
                selectedPatient?.scenario_type || ''
            );
            this.form.scenario_type = configuredScenario && available.some(
                (item: any) => this.scenarioValue(item) === configuredScenario
            )
                ? configuredScenario
                : '';
            this.promptSelectionMode = this.form.scenario_type ? 'auto' : '';
            this.promptMismatchAcknowledged = false;
            return;
        }
        this.form.scenario_type = '';
        this.promptSelectionMode = '';
        this.promptMismatchAcknowledged = false;
    }

    private normalizeRequestedPatientId(value: any) {
        const requestedPatientId = String(value || '').trim().toLowerCase();
        return /^[0-9a-f]{32}$/.test(requestedPatientId)
            ? requestedPatientId
            : '';
    }

    private rememberedContentPatientId() {
        try {
            return this.normalizeRequestedPatientId(
                window.sessionStorage.getItem(this.contentPatientStorageKey)
            );
        } catch (_error) {
            return '';
        }
    }

    private rememberContentPatientId(value: any) {
        const patientId = this.normalizeRequestedPatientId(value);
        try {
            if (patientId) {
                window.sessionStorage.setItem(
                    this.contentPatientStorageKey,
                    patientId
                );
            } else {
                window.sessionStorage.removeItem(this.contentPatientStorageKey);
            }
        } catch (_error) {
        }
    }

    private selectedPatientCode() {
        const patient = this.selectedPatientOption();
        return String(
            patient?.patient_code || patient?.code || patient?.pseudonym || ''
        ).trim();
    }

    private recordMatchesSelectedPatient(record: any) {
        const selectedPatientId = this.normalizeRequestedPatientId(
            this.form.patient_id
        );
        if (!selectedPatientId || !record || typeof record !== 'object') {
            return false;
        }
        const recordPatientId = this.normalizeRequestedPatientId(
            record?.patient_id
            || record?.patient?.id
            || record?.patient?.patient_id
        );
        if (recordPatientId) return recordPatientId === selectedPatientId;

        const selectedPatientCode = this.selectedPatientCode();
        const recordPatientCode = String(
            record?.patient_code
            || record?.patient?.patient_code
            || record?.patient?.code
            || ''
        ).trim();
        return !!selectedPatientCode && recordPatientCode === selectedPatientCode;
    }

    private clearPatientContent() {
        this.jobs = [];
        this.assets = [];
        this.metrics = {};
        this.videoMetrics = {};
        this.total = 0;
        this.selectedAsset = null;
        this.selectedReviewAssetId = '';
        this.confirmedReviewAssetId = '';
        this.progressJobId = '';
        this.progressReturnFocus = null;
        this.selectedVideoSource = null;
        this.selectedVideoResultModelKey = 'all';
        this.selectedAudioSource = null;
        this.selectedIntensityVideoSources = {};
        this.latestVideoBatchId = '';
        this.clearLatestImageCostBatch();
    }

    private applySearchPayload(payload: any) {
        if (
            payload?.patient_scoped !== true
            || !this.normalizeRequestedPatientId(this.form.patient_id)
        ) {
            this.clearPatientContent();
            this.searchError = '선택한 환자의 콘텐츠 범위를 확인하지 못했습니다. 다시 시도해주세요.';
            return;
        }

        const jobKeys = ['jobs', 'generation_jobs'];
        const assetKeys = ['assets', 'artifacts', 'media_assets'];
        const rawJobs = this.extractList(payload, jobKeys);
        const jobs = rawJobs.filter(
            (item: any) => this.recordMatchesSelectedPatient(item)
        );
        const assets = this.extractList(payload, assetKeys)
            .filter((item: any) => this.recordMatchesSelectedPatient(item));
        this.page = Number(payload?.page || this.page || 1);
        this.dump = Number(payload?.dump || this.dump || 20);
        const metrics = this.metricPayload(payload?.metrics);
        this.metrics = String(metrics?.scope || '').toLowerCase() === 'patient'
            ? metrics
            : {};
        const videoMetrics = this.metricPayload(payload?.video_metrics);
        this.videoMetrics = String(videoMetrics?.scope || '').toLowerCase() === 'patient'
            ? videoMetrics
            : {};

        if (this.hasListKey(payload, jobKeys)) this.jobs = jobs;
        if (this.hasListKey(payload, assetKeys)) this.assets = assets;
        else if (this.hasListKey(payload, jobKeys)) this.assets = this.assetsFromJobs(jobs);

        if (!Array.isArray(payload) && Array.isArray(payload?.items)) {
            const items = payload.items.filter(
                (item: any) => this.recordMatchesSelectedPatient(item)
            );
            const looksLikeAssets = items.some((item: any) =>
                !!(item?.asset_id || item?.artifact_id || item?.preview_url || item?.review_status)
            );
            if (looksLikeAssets && !this.hasListKey(payload, assetKeys)) this.assets = items;
            if (!looksLikeAssets && !this.hasListKey(payload, jobKeys)) this.jobs = items;
        }
        this.total = jobs.length === rawJobs.length
            ? Number(payload?.total ?? jobs.length)
            : jobs.length;
        this.searchError = '';
        if (!this.latestIntensityBatchId) {
            const latestBatchJob = [...this.jobs]
                .filter((job: any) => /^[0-9a-f]{32}$/.test(
                    String(job?.intensity_batch_id || '')
                ))
                .sort((left: any, right: any) => {
                    const leftTime = Date.parse(left?.created_at || left?.created || '') || 0;
                    const rightTime = Date.parse(right?.created_at || right?.created || '') || 0;
                    return rightTime - leftTime;
                })[0];
            this.latestIntensityBatchId = String(
                latestBatchJob?.intensity_batch_id || ''
            );
        }
        if (!this.latestVideoBatchId) {
            const latestVideoBatchJob = [...this.jobs]
                .filter((job: any) => /^[0-9a-f]{32}$/.test(
                    String(job?.video_batch_id || '')
                ))
                .sort((left: any, right: any) => {
                    const leftTime = Date.parse(left?.created_at || left?.created || '') || 0;
                    const rightTime = Date.parse(right?.created_at || right?.created || '') || 0;
                    return rightTime - leftTime;
                })[0];
            this.latestVideoBatchId = String(
                latestVideoBatchJob?.video_batch_id || ''
            );
        }
        const selectedId = this.assetId(this.selectedVideoSource);
        if (selectedId) {
            const refreshed = this.assets.find((item: any) => this.assetId(item) === selectedId);
            this.selectedVideoSource = refreshed || null;
        }
        const selectedAudioId = this.assetId(this.selectedAudioSource);
        if (selectedAudioId) {
            const refreshedAudio = this.assets.find((item: any) => this.assetId(item) === selectedAudioId);
            this.selectedAudioSource = refreshedAudio || null;
        }
        const refreshedIntensitySources: { [key: number]: any } = {};
        this.intensityOptions.forEach((intensity: number) => {
            const selected = this.selectedIntensityVideoSources[intensity];
            const selectedSourceId = this.assetId(selected);
            if (!selectedSourceId) return;
            const refreshedSource = this.assets.find(
                (item: any) => this.assetId(item) === selectedSourceId
            );
            if (refreshedSource) refreshedIntensitySources[intensity] = refreshedSource;
        });
        this.selectedIntensityVideoSources = refreshedIntensitySources;
    }

    private jobFromPayload(payload: any) {
        const candidate = payload?.job || payload?.generation_job || payload?.data || payload;
        if (!candidate || Array.isArray(candidate) || typeof candidate !== 'object') return null;
        if (!candidate.id && candidate.job_id) return { ...candidate, id: candidate.job_id };
        return candidate;
    }

    private videoEstimateSeconds(job: any = null) {
        const distribution = this.videoLatencyDistribution();
        let low = distribution.count > 0 ? distribution.avgSeconds : 0;
        let high = distribution.count > 0 ? distribution.p95Seconds : 0;
        if (low <= 0 || high <= 0) {
            const duration = this.videoDurationForJob(job);
            const fallback: any = {
                3: { low: 120, high: 300 },
                5: { low: 240, high: 480 },
                7: { low: 360, high: 720 },
                10: { low: 480, high: 900 },
                15: { low: 720, high: 1200 },
                20: { low: 900, high: 1500 }
            };
            const estimate = fallback[duration] || fallback[3];
            low = estimate.low;
            high = estimate.high;
        }

        const status = String(job?.status || '').toLowerCase();
        if (status === 'postprocessing') return { low: 30, high: 90 };
        if (job && status === 'running') {
            const startedAt = new Date(job?.started_at || job?.created_at || job?.created || 0).getTime();
            if (Number.isFinite(startedAt) && startedAt > 0) {
                const elapsed = Math.max(0, (Date.now() - startedAt) / 1000);
                low = Math.max(30, low - elapsed);
                high = Math.max(60, high - elapsed);
            }
        }
        return {
            low: Math.max(30, Math.min(low, high)),
            high: Math.max(60, Math.max(low, high))
        };
    }

    private videoLatencyDistribution() {
        const latency = this.videoMetrics?.latency_ms?.total || {};
        const count = Math.max(0, Number(latency?.count || 0));
        const avgSeconds = Math.max(0, Number(latency?.avg || 0) / 1000);
        const p95Seconds = Math.max(avgSeconds, Number(latency?.p95 || 0) / 1000);
        return {
            count: Number.isFinite(count) ? count : 0,
            avgSeconds: Number.isFinite(avgSeconds) ? avgSeconds : 0,
            p95Seconds: Number.isFinite(p95Seconds) ? p95Seconds : 0
        };
    }

    private videoDurationForJob(job: any) {
        const value = Number(job?.video_duration_seconds || this.videoDurationSeconds || 3);
        return [3, 5, 7, 10, 15, 20].includes(value) ? value : 3;
    }

    private durationRangeLabel(lowSeconds: number, highSeconds: number) {
        const lowMinutes = Math.max(1, Math.ceil(lowSeconds / 60));
        const highMinutes = Math.max(lowMinutes, Math.ceil(highSeconds / 60));
        return lowMinutes === highMinutes
            ? `${lowMinutes}분`
            : `${lowMinutes}~${highMinutes}분`;
    }

    private candidateJobsFromPayload(payload: any, expectedCount: number): any[] | null {
        if (!Number.isInteger(expectedCount) || expectedCount < 1) return null;
        if (Number(payload?.candidate_count) !== expectedCount) return null;
        const jobs = this.extractList(payload, ['jobs', 'generation_jobs']);
        if (jobs.length !== expectedCount) return null;

        const normalized = jobs.map((job: any) => this.jobFromPayload(job));
        if (normalized.some((job: any) => !job || !this.jobId(job))) return null;
        const ids = normalized.map((job: any) => this.jobId(job));
        if (new Set(ids).size !== expectedCount) return null;

        const batchIds = normalized.map((job: any) => String(job?.candidate_batch_id || ''));
        if (batchIds.some((batchId: string) => !batchId) || new Set(batchIds).size !== 1) return null;
        if (normalized.some((job: any) => Number(job?.candidate_count) !== expectedCount)) return null;
        const indexes = normalized.map((job: any) => Number(job?.candidate_index));
        if (
            new Set(indexes).size !== expectedCount
            || ![...indexes].sort((left: number, right: number) => left - right)
                .every((value: number, index: number) => value === index + 1)
        ) return null;
        return normalized;
    }

    private intensityBatchJobsFromPayload(payload: any, candidateCount: number): any[] | null {
        const expectedCandidateCount = this.normalizeCandidateCount(candidateCount);
        const expectedTotal = expectedCandidateCount * 5;
        if (Number(payload?.candidate_count) !== expectedCandidateCount) return null;
        if (Number(payload?.total_job_count) !== expectedTotal) return null;
        const intensityBatchId = String(payload?.intensity_batch_id || '');
        if (!/^[0-9a-f]{32}$/.test(intensityBatchId)) return null;
        const jobs = this.extractList(payload, ['jobs', 'generation_jobs']);
        if (jobs.length !== expectedTotal) return null;
        const normalized = jobs.map((job: any) => this.jobFromPayload(job));
        if (normalized.some((job: any) => !job || !this.jobId(job))) return null;
        if (new Set(normalized.map((job: any) => this.jobId(job))).size !== expectedTotal) return null;
        if (normalized.some((job: any) => (
            String(job?.intensity_batch_id || '') !== intensityBatchId
            || Number(job?.candidate_count) !== expectedCandidateCount
        ))) return null;
        for (const intensity of this.intensityOptions) {
            const rows = normalized.filter((job: any) => this.jobIntensity(job) === intensity);
            if (rows.length !== expectedCandidateCount) return null;
            const indexes = rows.map((job: any) => Number(job?.candidate_index)).sort(
                (left: number, right: number) => left - right
            );
            if (!indexes.every((value: number, index: number) => value === index + 1)) return null;
            if (new Set(rows.map((job: any) => String(job?.candidate_batch_id || ''))).size !== 1) return null;
        }
        return normalized;
    }

    private assetsFromPayload(payload: any) {
        const assets = this.extractList(payload, ['assets', 'artifacts', 'media_assets', 'results']);
        if (assets.length > 0) return assets;
        const jobs = this.extractList(payload, ['jobs', 'generation_jobs']);
        if (jobs.length > 0) return this.assetsFromJobs(jobs);
        const job = this.jobFromPayload(payload);
        return job ? this.assetsFromJobs([job]) : [];
    }

    private assetsFromJobs(jobs: any[]) {
        if (!Array.isArray(jobs)) return [];
        return jobs
            .filter((job: any) => !!(job?.asset || job?.artifact || job?.asset_revision))
            .map((job: any) => ({
                ...(job.asset || job.artifact || job.asset_revision),
                job_id: this.jobId(job),
                patient_id: job.patient_id,
                patient_code: job.patient_code,
                scenario_type: job.scenario_type,
                media_type: this.mediaType(job),
                intensity: job.intensity,
                candidate_batch_id: job.candidate_batch_id,
                candidate_index: job.candidate_index,
                candidate_count: job.candidate_count,
                intensity_batch_id: job.intensity_batch_id,
                video_batch_id: job.video_batch_id,
                replaces_job_id: job.replaces_job_id,
                review_decision: job.review_decision,
                job_status: job.status,
                started_at: job.started_at,
                completed_at: job.completed_at,
                generation_usage: job.generation_usage,
                review_status: job.review_status || job.asset?.review_status,
                signed_url: job.signed_url || job.preview_url || job.asset?.signed_url,
                artifacts: job.artifacts || job.asset?.artifacts || []
            }));
    }

    private upsertJob(job: any, prepend: boolean = false) {
        if (!this.recordMatchesSelectedPatient(job)) return;
        const id = this.jobId(job);
        if (!id) return;
        const index = this.jobs.findIndex((item: any) => this.jobId(item) === id);
        if (index >= 0) {
            this.jobs[index] = { ...this.jobs[index], ...job };
            this.jobs = [...this.jobs];
            return;
        }
        this.jobs = prepend ? [job, ...this.jobs] : [...this.jobs, job];
    }

    private mergeAssets(incoming: any[]) {
        if (!Array.isArray(incoming) || incoming.length === 0) return;
        const merged = [...this.assets];
        incoming
            .filter((asset: any) => this.recordMatchesSelectedPatient(asset))
            .forEach((asset: any) => {
                const id = this.assetId(asset);
                const index = merged.findIndex((item: any) => this.assetId(item) === id);
                if (id && index >= 0) {
                    const previousUrl = this.masterUrl(merged[index]);
                    merged[index] = { ...merged[index], ...asset };
                    if (this.masterUrl(merged[index]) !== previousUrl) delete merged[index].preview_failed;
                }
                else merged.unshift(asset);
            });
        this.assets = merged;
    }

    private startPolling() {
        if (this.pollTimer || this.destroyed) return;
        this.pollTimer = window.setInterval(() => {
            this.pollActiveJobs();
        }, 3000);
    }

    private async pollActiveJobs() {
        if (this.polling || this.destroyed) return;
        const active = this.jobs
            .filter((job: any) => ['queued', 'running', 'postprocessing'].includes(String(job?.status || '').toLowerCase()))
            .slice(0, 6);
        if (active.length === 0) return;

        this.polling = true;
        try {
            await Promise.all(active.map((job: any) => this.refreshJob(this.jobId(job), false)));
            if (!this.destroyed) await this.service.render();
        } finally {
            this.polling = false;
        }
    }

    private async refreshJob(id: string, render: boolean = true) {
        if (!id || this.destroyed) return;
        try {
            const { code, data } = await wiz.call('job_status', { job_id: id });
            if (code !== 200) return;
            const job = this.jobFromPayload(data);
            if (job) this.upsertJob(this.jobId(job) ? job : { ...job, id: id });
            this.mergeAssets(this.assetsFromPayload(data));
            if (render && !this.destroyed) await this.service.render();
        } catch (error) {
            // Poll failures are intentionally silent; the next interval retries.
        }
    }
}

export default PageContentComponent;